import type { JSX } from "react";

type SvgProps = {
	color: string;
	height: number | undefined;
};

type SvgComponent = (props: SvgProps) => JSX.Element;

export const icons = {
	// new icons:
	ALERT_EXCLAMATION: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 2 12"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="2" height="9" rx="1" fill="#D17300" />
			<rect y="10" width="2" height="2" rx="1" fill="#D17300" />
		</svg>
	),
	ALERT_FILLED: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 2 12"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="2" height="9" rx="1" fill="#D17300" />
			<rect y="10" width="2" height="2" rx="1" fill="#D17300" />
		</svg>
	),
	ALERT: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18.734 28.9043C19.0709 28.5674 19.5277 28.3779 20.0042 28.3774C20.4807 28.3779 20.9375 28.5674 21.2745 28.9043C21.6114 29.2412 21.8009 29.698 21.8013 30.1745L21.8012 30.1884C21.8008 30.6648 21.6115 31.1223 21.2745 31.4592C20.9376 31.7961 20.4808 31.9857 20.0042 31.9861C19.5277 31.9857 19.0709 31.7961 18.734 31.4592C18.397 31.1223 18.2075 30.6655 18.2071 30.189V30.1745C18.2075 29.698 18.397 29.2412 18.734 28.9043Z"
				fill="#C73535"
			/>
			<path
				d="M19.1571 25.638C19.3818 25.8626 19.6865 25.9889 20.0042 25.9889C20.322 25.9889 20.6267 25.8626 20.8514 25.638C21.0761 25.4134 21.2023 25.1089 21.2023 24.7912V14.0122C21.2023 13.6945 21.0761 13.39 20.8514 13.1654C20.6267 12.9408 20.322 12.8145 20.0042 12.8145C19.6865 12.8145 19.3818 12.9408 19.1571 13.1654C18.9324 13.39 18.8062 13.6945 18.8062 14.0122V24.7912C18.8062 25.1089 18.9324 25.4134 19.1571 25.638Z"
				fill="#C73535"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.8311 2.53341C21.2776 2.20706 20.6468 2.03501 20.0042 2.03516C19.3604 2.03402 18.7281 2.20554 18.1734 2.53224C17.6187 2.85895 17.1619 3.32858 16.8509 3.8921V3.90029L1.27765 32.6445C0.976804 33.1915 0.823696 33.8074 0.833446 34.4316C0.843196 35.0558 1.01544 35.6666 1.33323 36.204C1.65101 36.7413 2.10336 37.1866 2.64571 37.496C3.18806 37.8054 3.80168 37.9683 4.42613 37.9685H35.5759C36.2004 37.968 36.814 37.8048 37.3563 37.4952C37.8986 37.1856 38.3508 36.7402 38.6686 36.2028C38.9863 35.6653 39.1586 35.0543 39.1684 34.43C39.1781 33.8058 39.0251 33.19 38.7244 32.6429L23.1511 3.89873V3.89054C22.8404 3.32827 22.3846 2.85977 21.8311 2.53341ZM20.6109 4.59581C20.7948 4.7038 20.9466 4.8591 21.0505 5.04533L36.6334 33.7957C36.7341 33.9782 36.7856 34.1839 36.7827 34.3922C36.7798 34.6006 36.7227 34.8045 36.6169 34.9841C36.5111 35.1636 36.3604 35.3124 36.1795 35.416C35.9987 35.5196 35.7939 35.5743 35.5855 35.5747H4.43574C4.22743 35.5747 4.0227 35.5204 3.84177 35.4172C3.66085 35.314 3.50996 35.1657 3.404 34.9864C3.29805 34.8071 3.24069 34.6032 3.23757 34.395C3.23445 34.1868 3.28567 33.9812 3.38621 33.7989V33.7895L18.9579 5.04533C19.0618 4.8591 19.2136 4.7038 19.3975 4.59581C19.5815 4.48783 19.7909 4.4309 20.0042 4.4309C20.2175 4.4309 20.427 4.48783 20.6109 4.59581Z"
				fill="#C73535"
			/>
		</svg>
	),
	ALARM_BELL: ({ color, height }) => (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24" height={height} fill={color}>
			<g>
				<path d="M9.99 24.001c-.47 0-.939-.12-1.356-.348-.665-.363-1.149-.964-1.362-1.691-.117-.397.111-.814.508-.931.069-.02.14-.03.211-.03.33 0 .626.221.72.538.101.343.329.626.642.798.197.107.417.164.638.164.127 0 .255-.019.379-.055.438-.129.777-.468.906-.906.093-.317.389-.539.72-.539.071 0 .141.01.21.03.397.117.626.534.509.931-.273.931-.992 1.65-1.923 1.923-.262.077-.532.116-.802.116zM.991 19.501c-.285 0-.549-.165-.674-.421-.127-.26-.094-.563.083-.791.006-.009 1.341-1.939 1.341-7.788 0-4.293 3.266-7.835 7.5-8.216V.751c0-.414.336-.75.75-.75s.75.336.75.75v1.534c4.234.381 7.5 3.923 7.5 8.216 0 6.303 1.246 7.686 1.258 7.699.218.199.297.532.187.818-.114.293-.387.483-.695.483h-18zm16.71-1.5c-.482-1.232-.961-3.47-.961-7.5 0-3.722-3.028-6.75-6.75-6.75s-6.75 3.028-6.75 6.75c0 3.957-.58 6.277-1.046 7.5h15.507z" />
			</g>
		</svg>
	),
	BANK: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.12179 9.96033C1.93516 9.9598 1.7539 9.89772 1.60611 9.78374C1.45833 9.66975 1.35228 9.51022 1.30435 9.32985C1.25642 9.14947 1.2693 8.9583 1.34101 8.786C1.41272 8.61369 1.53926 8.46985 1.70101 8.37674L12.6491 2.12733C13.0559 1.8805 13.5227 1.75 13.9985 1.75C14.4744 1.75 14.9411 1.8805 15.3479 2.12733L26.296 8.37674C26.4578 8.46985 26.5843 8.61369 26.656 8.786C26.7278 8.9583 26.7406 9.14947 26.6927 9.32985C26.6448 9.51022 26.5387 9.66975 26.3909 9.78374C26.2431 9.89772 26.0619 9.9598 25.8753 9.96033H2.12179ZM5.31946 8.26366H22.6787L14.4962 3.59214L14.4713 3.57743C14.3293 3.49068 14.1661 3.44478 13.9997 3.44478C13.8332 3.44478 13.67 3.49068 13.528 3.57743L13.5031 3.59214L5.31946 8.26366Z"
				fill="currentColor"
			/>
			<path
				d="M25.8752 26.2484H2.12178C1.89678 26.2484 1.681 26.159 1.5219 25.9999C1.36281 25.8408 1.27344 25.625 1.27344 25.4C1.27344 25.175 1.36281 24.9593 1.5219 24.8002C1.681 24.6411 1.89678 24.5517 2.12178 24.5517H25.8752C26.1002 24.5517 26.316 24.6411 26.4751 24.8002C26.6342 24.9593 26.7236 25.175 26.7236 25.4C26.7236 25.625 26.6342 25.8408 26.4751 25.9999C26.316 26.159 26.1002 26.2484 25.8752 26.2484Z"
				fill="currentColor"
			/>
			<path
				d="M20.7852 22.9908H24.1786C24.4035 22.9908 24.6193 22.9014 24.7784 22.7423C24.9375 22.5832 25.0269 22.3675 25.0269 22.1425V12.3696C25.0269 12.1446 24.9375 11.9289 24.7784 11.7698C24.6193 11.6107 24.4035 11.5213 24.1786 11.5213C23.9536 11.5213 23.7378 11.6107 23.5787 11.7698C23.4196 11.9289 23.3302 12.1446 23.3302 12.3696V21.2941H21.6335V12.3696C21.6335 12.1446 21.5442 11.9289 21.3851 11.7698C21.226 11.6107 21.0102 11.5213 20.7852 11.5213C20.5602 11.5213 20.3444 11.6107 20.1853 11.7698C20.0262 11.9289 19.9369 12.1446 19.9369 12.3696V22.1425C19.9369 22.3675 20.0262 22.5832 20.1853 22.7423C20.3444 22.9014 20.5602 22.9908 20.7852 22.9908Z"
				fill="currentColor"
			/>
			<path
				d="M15.6952 22.9908H12.3018C12.0768 22.9908 11.8611 22.9014 11.702 22.7423C11.5429 22.5832 11.4535 22.3675 11.4535 22.1425V12.3696C11.4535 12.1446 11.5429 11.9289 11.702 11.7698C11.8611 11.6107 12.0768 11.5213 12.3018 11.5213C12.5268 11.5213 12.7426 11.6107 12.9017 11.7698C13.0608 11.9289 13.1502 12.1446 13.1502 12.3696V21.2941H14.8469V12.3696C14.8469 12.1446 14.9362 11.9289 15.0953 11.7698C15.2544 11.6107 15.4702 11.5213 15.6952 11.5213C15.9202 11.5213 16.136 11.6107 16.2951 11.7698C16.4542 11.9289 16.5435 12.1446 16.5435 12.3696V22.1425C16.5435 22.3675 16.4542 22.5832 16.2951 22.7423C16.136 22.9014 15.9202 22.9908 15.6952 22.9908Z"
				fill="currentColor"
			/>
			<path
				d="M3.81844 22.9908H7.21179C7.43679 22.9908 7.65257 22.9014 7.81166 22.7423C7.97076 22.5832 8.06013 22.3675 8.06013 22.1425V12.3696C8.06013 12.1446 7.97076 11.9289 7.81166 11.7698C7.65257 11.6107 7.43679 11.5213 7.21179 11.5213C6.9868 11.5213 6.77102 11.6107 6.61192 11.7698C6.45283 11.9289 6.36345 12.1446 6.36345 12.3696V21.2941H4.66678V12.3696C4.66678 12.1446 4.57741 11.9289 4.41831 11.7698C4.25922 11.6107 4.04343 11.5213 3.81844 11.5213C3.59345 11.5213 3.37766 11.6107 3.21857 11.7698C3.05948 11.9289 2.9701 12.1446 2.9701 12.3696V22.1425C2.9701 22.3675 3.05948 22.5832 3.21857 22.7423C3.37766 22.9014 3.59345 22.9908 3.81844 22.9908Z"
				fill="currentColor"
			/>
		</svg>
	),
	BANKID: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 24 25"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.2191 0.181641H9.68028L8.93732 5.57687H9.88897C10.4065 5.57687 10.9032 5.31767 11.1078 4.90967C11.1704 4.78967 11.2121 4.66967 11.2121 4.57846C11.2121 4.36246 11.0869 4.17526 10.945 4.07926C10.5735 3.77206 10.5109 3.43606 10.5109 3.20086V3.08086C10.5944 2.50965 11.2538 1.89045 12.1429 1.89045C12.6813 1.89045 13.0737 2.03445 13.3199 2.29365C13.5286 2.53365 13.6288 2.86486 13.5662 3.19606C13.4827 3.59926 13.1321 3.93046 12.9276 4.09846C12.3892 4.52566 12.4518 4.90487 12.4935 5.02487C12.5979 5.35607 13.0319 5.57207 13.3617 5.57207H14.81C16.7718 5.59607 17.8278 6.61848 17.4772 9.04249C17.1683 11.2745 15.6782 12.2489 13.9043 12.2729L13.1613 17.4281H14.1965C18.5958 17.4281 22.1729 14.1737 22.8949 9.06169C23.7715 2.72565 20.2612 0.181641 15.2191 0.181641ZM7.92305 12.7048L8.83297 6.02801H7.83957C7.38461 6.02801 6.78774 5.74481 6.59991 5.1976C6.5373 5.0056 6.41208 4.3672 7.18009 3.748C7.44722 3.53199 7.63505 3.29679 7.65592 3.10479C7.69766 2.91279 7.65592 2.74959 7.5307 2.60559C7.38461 2.43759 7.05487 2.32239 6.64165 2.32239C5.94043 2.32239 5.44373 2.79759 5.40199 3.12879C5.36025 3.38799 5.54808 3.57999 5.68999 3.7C6.12408 4.0792 6.22843 4.6264 5.95713 5.1496C5.66912 5.67281 5.06808 6.02801 4.42947 6.02801H3.4152C3.37799 6.31472 3.08616 8.45654 2.76523 10.8119L2.76522 10.812C2.3662 13.7405 1.92219 16.9992 1.86667 17.4329H7.32618C7.34705 17.1017 7.59331 15.2009 7.92305 12.7048ZM1.56199 19.7368H3.79504C4.7467 19.7368 4.97209 20.284 4.90948 20.8072C4.84688 21.2104 4.62148 21.5224 4.18739 21.7096C4.72583 21.9496 4.93035 22.3048 4.84688 22.876C4.74253 23.5912 4.20826 24.1096 3.50287 24.1096H0.960938L1.56199 19.7368ZM3.02704 21.5656C3.46113 21.5656 3.66565 21.3064 3.70739 20.9944C3.74913 20.6632 3.62391 20.4232 3.18982 20.4232H2.79747L2.63051 21.5656H3.02704ZM2.78078 23.4664C3.23573 23.4664 3.482 23.2504 3.54461 22.8232C3.58635 22.468 3.41939 22.228 2.9853 22.228H2.55121L2.38425 23.4616H2.78078V23.4664ZM7.94393 24.1576C7.36376 24.2056 7.07575 24.1336 6.95054 23.8504C6.64166 24.0664 6.31192 24.1816 5.93627 24.1816C5.27679 24.1816 5.04722 23.8024 5.10983 23.3512C5.1307 23.1352 5.23505 22.948 5.4187 22.78C5.6075 22.5887 5.95848 22.4866 6.29697 22.388L6.29699 22.388C6.5871 22.3035 6.86803 22.2217 7.02984 22.0888C7.05071 21.7816 6.94636 21.6616 6.61662 21.6616C6.22427 21.6616 5.9154 21.8056 5.35609 22.2328L5.48131 21.2344C5.95714 20.8312 6.4121 20.6632 6.94636 20.6632C7.62671 20.6632 8.22776 20.9704 8.10254 21.8296L7.97732 22.804C7.93558 23.1352 7.93558 23.2552 8.26533 23.2552L7.94393 24.1576ZM6.95471 22.66C6.85036 22.733 6.71505 22.7786 6.5792 22.8243C6.31291 22.914 6.04451 23.0044 6.00305 23.3032C5.98218 23.5192 6.08653 23.6824 6.27018 23.6824C6.45384 23.6824 6.6834 23.5864 6.85036 23.4424C6.83266 23.3814 6.84499 23.303 6.86187 23.1957L6.86188 23.1956C6.8649 23.1765 6.86807 23.1563 6.87123 23.1352L6.95471 22.66ZM10.1978 20.7353H9.04166L8.56583 24.1097H9.72201L9.98914 22.1369C10.1561 21.9017 10.3189 21.7817 10.5067 21.7817C10.7321 21.7817 10.8156 21.9497 10.7738 22.2809L10.5276 24.1337H11.6838L11.9968 21.8969C12.1012 21.1385 11.7881 20.6873 11.1495 20.6873C10.7738 20.6873 10.5067 20.8313 10.1352 21.1865L10.1978 20.7353ZM12.9026 19.7368H14.0629L13.7749 21.8969L14.8894 20.7304H16.3169L14.8894 22.18L16.0247 24.1337H14.5596L13.6706 22.5641H13.6497L13.441 24.1337H12.2849L12.9026 19.7368ZM18.3412 19.7368H16.9972L16.3962 24.1097H17.7402L18.3412 19.7368ZM18.9798 19.7368H20.879C22.344 19.7368 22.7781 20.9704 22.6362 21.9929C22.511 22.9913 21.8098 24.1337 20.5284 24.1337H18.3996L18.9798 19.7368ZM20.2195 23.0873C20.8581 23.0873 21.2338 22.7321 21.3339 21.9449C21.4174 21.3736 21.2504 20.8024 20.5492 20.8024H20.1777L19.8689 23.1065L20.2195 23.0873Z"
			/>
		</svg>
	),
	BANKID_CIRCLE: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 81 80"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="40.5" cy="40" r="40" fill="#E8F6F9" />
			<path
				d="M36.9975 24.0894H45.3834C52.9781 24.0894 58.2838 27.4227 56.9653 35.7769C55.8999 42.5066 50.4781 46.7681 43.8433 46.7681H42.2716L43.337 39.9751C46.0268 39.954 48.2841 38.6882 48.7482 35.7452C49.244 32.5807 47.6618 31.22 44.7083 31.1989V31.1884H42.5353C42.0396 31.1884 41.3961 30.9036 41.2273 30.4606C41.1746 30.3129 41.0691 29.8171 41.8813 29.2475C42.1872 29.026 42.7252 28.583 42.8412 28.045C42.9362 27.5914 42.8096 27.159 42.4826 26.8531C42.1134 26.505 41.5016 26.3151 40.6999 26.3151C39.3603 26.3151 38.3477 27.1273 38.2316 27.8762C38.2211 27.929 38.2211 27.9817 38.2211 28.045C38.2211 28.3509 38.3371 28.7834 38.8856 29.1948C39.0861 29.3424 39.2865 29.564 39.2865 29.8593C39.2865 29.9964 39.2443 30.1441 39.1388 30.3129C38.8223 30.8297 38.084 31.1884 37.3034 31.1884H35.8794L36.9975 24.0894Z"
				fill="#193E4F"
			/>
			<path
				d="M35.7423 31.7579L34.3499 40.5341C34.0408 42.4961 33.7807 44.1714 33.6058 45.2982C33.4883 46.0551 33.4091 46.5647 33.3795 46.747H25.1729C25.2408 46.3035 25.66 43.6397 26.1266 40.6745C26.7477 36.7275 27.4529 32.2458 27.5252 31.7579H29.0441C30.0251 31.7474 30.9428 31.2938 31.3648 30.5976C31.7761 29.9225 31.6179 29.2052 30.9534 28.7095C30.7319 28.5407 30.4787 28.277 30.5314 27.95C30.6053 27.507 31.3542 26.8952 32.4196 26.8952C33.0525 26.8952 33.5482 27.0323 33.8014 27.2749C33.9807 27.4437 34.044 27.6652 33.9913 27.9184C33.9385 28.161 33.6748 28.4774 33.2634 28.7622C32.1137 29.5744 32.3141 30.4077 32.3985 30.6504C32.6622 31.3676 33.5588 31.7579 34.255 31.7579H35.7423Z"
				fill="#193E4F"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M28.0948 49.7849H24.7299L23.8333 55.5443H27.6623C28.7277 55.5443 29.5399 54.8481 29.6876 53.9093C29.8036 53.1604 29.4872 52.6857 28.6855 52.3798C29.3184 52.1161 29.6876 51.7153 29.772 51.1773C29.8775 50.5128 29.5294 49.7849 28.0948 49.7849ZM27.9788 51.4094C27.9155 51.8208 27.6096 52.1688 26.9556 52.1688H26.3754L26.6075 50.6604H27.1877C27.8416 50.6604 28.0421 50.9663 27.9788 51.4094ZM27.7573 53.8144C27.6623 54.3734 27.272 54.6477 26.597 54.6477V54.6582H25.9957L26.2489 53.0443H26.9028C27.5568 53.0443 27.8311 53.3291 27.7573 53.8144Z"
				fill="#193E4F"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M34.4026 55.5864C33.5271 55.6497 33.1052 55.5548 32.8943 55.1751C32.4301 55.4599 31.9133 55.6075 31.3648 55.6075C30.3732 55.6075 30.0251 55.0907 30.1201 54.5211C30.1623 54.2468 30.3205 53.9831 30.5736 53.7616C30.8751 53.5007 31.4188 53.3641 31.935 53.2344C32.3578 53.1281 32.7622 53.0265 32.9997 52.865C33.0419 52.4642 32.8837 52.3165 32.3879 52.3165C31.8078 52.3165 31.3226 52.5064 30.4893 53.076L30.6897 51.768C31.407 51.2511 32.1031 51.0085 32.9048 51.0085C33.928 51.0085 34.8351 51.4304 34.6664 52.5486L34.4659 53.8143C34.3921 54.2574 34.4132 54.3945 34.909 54.405L34.4026 55.5864ZM32.3112 53.815C31.9163 53.9303 31.522 54.0455 31.4597 54.4472C31.4175 54.732 31.5968 54.943 31.8816 54.943C32.1559 54.943 32.4934 54.827 32.7677 54.6371C32.7466 54.5316 32.7571 54.4261 32.7888 54.2257L32.8837 53.5928C32.7243 53.6943 32.5177 53.7546 32.3112 53.815Z"
				fill="#193E4F"
			/>
			<path
				d="M37.7886 51.0823H36.0376L35.352 55.5232H37.103L37.5038 52.9177C37.7464 52.5907 37.9996 52.4431 38.2739 52.4431C38.6114 52.4431 38.7485 52.654 38.6747 53.0971L38.2949 55.5337H40.046L40.4995 52.5907C40.6578 51.6098 40.2042 51.0085 39.2232 51.0085C38.6747 51.0085 38.2528 51.1878 37.6937 51.6625L37.7886 51.0823Z"
				fill="#193E4F"
			/>
			<path
				d="M41.8708 49.7849H43.6218L43.1788 52.6119L44.856 51.0824H47.0183L44.8665 52.9811L46.5964 55.5337H44.3918L43.0628 53.4663H43.0417L42.7252 55.5232H40.9742L41.8708 49.7849Z"
				fill="#193E4F"
			/>
			<path d="M50.0773 49.7849H48.0626L47.1765 55.5337H49.1912L50.0773 49.7849Z" fill="#193E4F" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M51.0583 49.7849H53.938C56.1637 49.7849 56.8071 51.3988 56.5961 52.7384C56.3957 54.0464 55.362 55.5337 53.4106 55.5337H50.1617L51.0583 49.7849ZM52.9253 54.1625C53.9063 54.1625 54.4443 53.6772 54.6025 52.6541C54.7185 51.8946 54.4865 51.1457 53.4 51.1457H52.8621L52.3979 54.1625H52.9253Z"
				fill="#193E4F"
			/>
		</svg>
	),
	CALENDAR: ({ color, height }) => (
		<svg
			fill={color}
			version="1.1"
			height={height}
			viewBox="0 0 600.112 600.111"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M537.423,52.563h-59.836V21.92c0-11.83-9.591-21.42-21.42-21.42c-11.83,0-21.42,9.59-21.42,21.42v30.642H165.364V21.92     c0-11.83-9.59-21.42-21.42-21.42c-11.83,0-21.42,9.59-21.42,21.42v30.642H62.687c-32.058,0-58.14,26.082-58.14,58.14v430.77     c0,32.059,26.082,58.139,58.14,58.139h474.736c32.059,0,58.141-26.08,58.141-58.139v-430.77     C595.564,78.645,569.482,52.563,537.423,52.563z M47.387,110.703c0-8.451,6.85-15.3,15.3-15.3h59.837v24.443     c0,11.83,9.59,21.42,21.42,21.42s21.42-9.59,21.42-21.42V95.403h269.383v24.443c0,11.83,9.59,21.42,21.42,21.42     c11.829,0,21.42-9.59,21.42-21.42V95.403h59.836c8.45,0,15.3,6.85,15.3,15.3v53.856H47.387V110.703z M552.723,541.473     c0,8.449-6.85,15.301-15.3,15.301H62.687c-8.45,0-15.3-6.852-15.3-15.301V207.399h505.336V541.473z" />
			<path d="M537.423,600.111H62.687c-32.334,0-58.64-26.306-58.64-58.639v-430.77c0-32.334,26.306-58.64,58.64-58.64h59.336V21.92     c0-12.087,9.833-21.92,21.92-21.92c12.086,0,21.92,9.833,21.92,21.92v30.142h268.384V21.92c0-12.087,9.833-21.92,21.92-21.92     s21.92,9.833,21.92,21.92v30.143h59.336c32.335,0,58.641,26.306,58.641,58.64v430.77     C596.064,573.806,569.758,600.111,537.423,600.111z M62.687,53.062c-31.783,0-57.64,25.857-57.64,57.64v430.77     c0,31.782,25.857,57.639,57.64,57.639h474.736c31.783,0,57.641-25.856,57.641-57.639v-430.77c0-31.783-25.857-57.64-57.641-57.64     h-60.336V21.92c0-11.536-9.385-20.92-20.92-20.92s-20.92,9.385-20.92,20.92v31.142H164.864V21.92     c0-11.536-9.385-20.92-20.92-20.92c-11.536,0-20.92,9.385-20.92,20.92v31.142H62.687z M537.423,557.273H62.687     c-8.712,0-15.8-7.088-15.8-15.801V206.899h506.336v334.574C553.223,550.186,546.135,557.273,537.423,557.273z M47.887,207.899     v333.574c0,8.161,6.639,14.801,14.8,14.801h474.736c8.16,0,14.8-6.64,14.8-14.801V207.899H47.887z M553.223,165.059H46.887     v-54.356c0-8.712,7.088-15.8,15.8-15.8h60.337v24.943c0,11.535,9.385,20.92,20.92,20.92s20.92-9.385,20.92-20.92V94.903h270.383     v24.943c0,11.535,9.385,20.92,20.92,20.92s20.92-9.385,20.92-20.92V94.903h60.336c8.712,0,15.8,7.088,15.8,15.8V165.059z      M47.887,164.059h504.336v-53.356c0-8.161-6.64-14.8-14.8-14.8h-59.336v23.943c0,12.087-9.833,21.92-21.92,21.92     s-21.92-9.833-21.92-21.92V95.903H165.864v23.943c0,12.087-9.833,21.92-21.92,21.92s-21.92-9.833-21.92-21.92V95.903H62.687     c-8.161,0-14.8,6.639-14.8,14.8V164.059z" />
		</svg>
	),
	CHECK: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M22.9015 0.952592C22.5922 0.729871 22.2072 0.639133 21.8311 0.700259C21.455 0.761384 21.1185 0.969223 20.8956 1.27842L7.4449 20.0419L2.95494 15.5449C2.77667 15.366 2.55447 15.2374 2.3107 15.1717C2.06692 15.1061 1.81016 15.1061 1.56626 15.1713C1.32238 15.2365 1.09998 15.3649 0.921416 15.5434C0.742851 15.722 0.614418 15.9442 0.549042 16.1881C0.483665 16.432 0.483655 16.689 0.548998 16.9329C0.61434 17.1769 0.742729 17.399 0.92127 17.5776L6.60919 23.2726C6.75863 23.4165 6.937 23.5271 7.13241 23.5966C7.32781 23.666 7.53577 23.6929 7.74243 23.6757C7.94909 23.6585 8.1497 23.5973 8.33091 23.4964C8.51212 23.3955 8.66975 23.2571 8.79332 23.0905L23.2321 2.95628C23.4533 2.64651 23.5428 2.26171 23.4808 1.88608C23.4188 1.51046 23.2105 1.1748 22.9015 0.952592Z" />
		</svg>
	),
	CHECKBOX_CHECKED: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 20 20"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="20" height="20" rx="4" fill="currentColor" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.29289 14.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.2929C3.68342 8.90238 4.31658 8.90238 4.70711 9.2929L8 12.5858L15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711L8.70945 14.7048M8.70711 14.7071C8.53625 14.878 8.31895 14.9741 8.09585 14.9954C8.06346 14.9985 8.03095 15 7.99844 15C7.80702 14.9997 7.61567 14.9448 7.44977 14.8352C7.39432 14.7986 7.34171 14.7559 7.29289 14.7071"
				fill="white"
			/>
		</svg>
	),
	CHECKBOX_UNCHECKED: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 20 20"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="20" height="20" rx="4" fill="currentColor" />
			<rect x="2" y="2" width="16" height="16" rx="2" fill="white" />
		</svg>
	),
	CHEVRON_DOWN: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 14 8"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.37429 0.5C1.48718 0.499915 1.59916 0.521402 1.70401 0.563388C1.80877 0.605338 1.90516 0.66728 1.98713 0.746596L6.99965 5.58169L12.0125 0.746283C12.1779 0.586732 12.3985 0.500148 12.6249 0.500148C12.8513 0.500148 13.0719 0.586717 13.2373 0.746283C13.4033 0.906443 13.5 1.12756 13.5 1.36203C13.5 1.59654 13.4033 1.81761 13.2373 1.97774L7.87728 7.14801C7.64162 7.37529 7.32569 7.5 6.9999 7.5C6.67409 7.5 6.35822 7.37531 6.12256 7.14805L0.762542 1.97775C0.639047 1.85847 0.552584 1.70412 0.517467 1.53359C0.482326 1.36295 0.50055 1.18626 0.569057 1.02665C0.637457 0.867293 0.752006 0.73397 0.895404 0.641436C1.03674 0.550233 1.20302 0.500146 1.37429 0.5Z"
				fill="#00699A"
			/>
		</svg>
	),
	CHEVRON: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 8 14"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.746284 0.762719C0.906443 0.596698 1.12756 0.5 1.36203 0.5C1.59653 0.5 1.81761 0.59673 1.97774 0.762719L7.14801 6.12272C7.37529 6.35838 7.5 6.67431 7.5 7.00011C7.5 7.32591 7.37531 7.64178 7.14805 7.87744L1.97775 13.2375C1.85847 13.361 1.70412 13.4474 1.53359 13.4825C1.36294 13.5177 1.18626 13.4995 1.02665 13.4309C0.867292 13.3625 0.73397 13.248 0.641437 13.1046C0.550233 12.9633 0.500146 12.797 0.5 12.6258C0.499915 12.5129 0.521402 12.4008 0.563388 12.296C0.60536 12.1912 0.667344 12.0947 0.746719 12.0127L5.58169 7.00035L0.746283 1.98751C0.586741 1.82212 0.500148 1.60151 0.500148 1.37512C0.500148 1.14874 0.586718 0.928125 0.746284 0.762719Z"
				fill="currentColor"
			/>
		</svg>
	),
	CHEVRON_LEFT: ({ color, height }) => (
		<svg
			className="-rotate-180"
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 8 14"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.746284 0.762719C0.906443 0.596698 1.12756 0.5 1.36203 0.5C1.59653 0.5 1.81761 0.59673 1.97774 0.762719L7.14801 6.12272C7.37529 6.35838 7.5 6.67431 7.5 7.00011C7.5 7.32591 7.37531 7.64178 7.14805 7.87744L1.97775 13.2375C1.85847 13.361 1.70412 13.4474 1.53359 13.4825C1.36294 13.5177 1.18626 13.4995 1.02665 13.4309C0.867292 13.3625 0.73397 13.248 0.641437 13.1046C0.550233 12.9633 0.500146 12.797 0.5 12.6258C0.499915 12.5129 0.521402 12.4008 0.563388 12.296C0.60536 12.1912 0.667344 12.0947 0.746719 12.0127L5.58169 7.00035L0.746283 1.98751C0.586741 1.82212 0.500148 1.60151 0.500148 1.37512C0.500148 1.14874 0.586718 0.928125 0.746284 0.762719Z"
				fill="currentColor"
			/>
		</svg>
	),
	CLOSE: ({ color, height }) => (
		<svg color={color} height={height} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11.8202 10.1413C11.801 10.1235 11.7858 10.1019 11.7757 10.0777C11.7656 10.0535 11.7608 10.0274 11.7616 10.0012C11.7631 9.94883 11.784 9.89895 11.8202 9.86106L19.1526 2.53013C19.2631 2.41973 19.3507 2.28866 19.4105 2.1444C19.4703 2.00013 19.5011 1.84558 19.5012 1.68941C19.5012 1.53324 19.4705 1.37872 19.4107 1.23442C19.351 1.09013 19.2634 0.958743 19.153 0.848287C19.0426 0.737831 18.9116 0.650394 18.7673 0.590595C18.623 0.530796 18.4684 0.500038 18.3122 0.5C18.156 0.499962 18.0014 0.530464 17.8571 0.590192C17.7128 0.64992 17.5817 0.737483 17.4712 0.847884L10.1396 8.17882C10.1023 8.21568 10.0519 8.2364 9.99943 8.2364C9.94696 8.2364 9.89656 8.21568 9.85921 8.17882L2.52757 0.847884C2.30322 0.631263 2.00278 0.511687 1.69093 0.514495C1.37908 0.517304 1.08079 0.642155 0.860375 0.862782C0.639965 1.08341 0.515094 1.38199 0.512591 1.69384C0.510089 2.00569 0.630196 2.30599 0.847037 2.53013L8.17868 9.86106C8.21485 9.89895 8.23569 9.94883 8.23721 10.0012C8.238 10.0274 8.23322 10.0535 8.22312 10.0777C8.21302 10.1019 8.19786 10.1235 8.17868 10.1413L0.847037 17.4722C0.699883 17.6213 0.594173 17.8061 0.540374 18.0086C0.486575 18.211 0.486543 18.4241 0.540273 18.6266C0.595803 18.8269 0.702777 19.0091 0.85056 19.1553C0.998344 19.3015 1.18179 19.4067 1.3827 19.4601C1.58361 19.5134 1.79499 19.5133 1.99583 19.4597C2.19667 19.4061 2.37997 19.3009 2.52757 19.1545L9.85921 11.8236C9.89656 11.7867 9.94696 11.766 9.99943 11.766C10.0519 11.766 10.1023 11.7867 10.1396 11.8236L17.4712 19.1545C17.6956 19.3711 17.9961 19.4907 18.3079 19.4879C18.6198 19.4851 18.918 19.3598 19.1384 19.1392C19.3588 18.9186 19.4838 18.6204 19.4863 18.3085C19.4888 17.9967 19.3687 17.6964 19.1518 17.4722L11.8202 10.1413Z"
				fill="currentColor"
			/>
		</svg>
	),
	ELLIPSIS: ({ color, height }) => (
		<svg viewBox="0 0 32 32" height={height}>
			<g fillRule="evenodd">
				<circle fill="#fff" cx="16" cy="16" r="16" />
				<path
					fill={color}
					d="M10 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
				/>
			</g>
		</svg>
	),
	DEBIT_CARD_B2B: ({ height }) => (
		<svg height={height} viewBox="0 0 240 153" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M240 143.408C240 148.166 236.182 152.02 231.464 152.02H8.53575C3.81784 152.02 0 148.166 0 143.408V8.62229C0 3.87416 3.82774 0.0200195 8.53575 0.0200195H231.454C236.172 0.0200195 239.99 3.87416 239.99 8.63223V143.408H240Z"
				fill="#002C50"
			/>
			<path
				d="M20.49 17.1101H17.39C16.27 17.1101 16.14 16.5501 16.14 16.1301C16.14 15.2501 16.6 14.8901 17.72 14.8901H23.72V12.4601H17.38C14.57 12.4601 13.26 13.6101 13.26 16.0901C13.26 18.4201 14.51 19.5001 17.18 19.5001H19.93C21.02 19.5001 21.36 19.7601 21.36 20.5601C21.36 21.2301 21.11 21.5901 19.77 21.5901H13.7V24.0201H20.14C22.94 24.0201 24.25 22.8901 24.25 20.4701C24.26 18.0801 23.17 17.1101 20.49 17.1101Z"
				fill="white"
			/>
			<path
				d="M33.66 12.4601L30.39 20.3801L27.2 12.4601H24.06L29.1 24.0201H31.81L36.64 12.4601H33.66Z"
				fill="white"
			/>
			<path
				d="M41.48 14.8401H45.54V12.4601H41.43C37.71 12.4601 35.97 14.3601 35.97 18.4401C35.97 20.5501 36.56 22.0401 37.76 22.9901C38.94 23.9401 40.09 24.0201 41.37 24.0201H45.54V21.6401H41.48C39.8 21.6401 39.13 21.0201 39.06 19.3601H45.54V16.9801H39.09C39.23 15.5201 39.99 14.8401 41.48 14.8401Z"
				fill="white"
			/>
			<path
				d="M50.91 12.4601L46.02 24.0201H48.98L49.97 21.3701H54.49L55.52 24.0201H58.61L53.68 12.4601H50.91ZM50.9 18.9501L52.21 15.5101L53.57 18.9501H50.9Z"
				fill="white"
			/>
			<path
				d="M58.06 29.2201H14.18C13.88 29.2201 13.63 28.9701 13.63 28.6701V26.7701C13.63 26.4701 13.88 26.2201 14.18 26.2201H58.06C58.36 26.2201 58.61 26.4701 58.61 26.7701V28.6701C58.61 28.9701 58.36 29.2201 58.06 29.2201Z"
				fill="#00ACC9"
			/>
			<path
				d="M56.1684 54.31V71.36C56.1684 73.0721 54.7805 74.46 53.0684 74.46H46.7577H35.0315H28.2684C26.5563 74.46 25.1684 73.0721 25.1684 71.36V54.31C25.1684 52.5979 26.5563 51.21 28.2684 51.21H35.0315H53.0684C54.7805 51.21 56.1684 52.5979 56.1684 54.31Z"
				fill="url(#paint0_linear_105_6602)"
			/>
			<path
				d="M35.0315 59.4799H25.3234M35.0315 59.4799C35.0315 59.4799 35.397 61.5165 35.4095 62.835C35.4231 64.2747 35.0315 66.5023 35.0315 66.5023M35.0315 59.4799C35.0315 59.4799 35.4083 56.9768 35.4095 55.3618C35.4107 53.7337 35.0315 51.21 35.0315 51.21M35.0315 66.5023H25.3234M35.0315 66.5023C35.0315 66.5023 35.4173 68.9838 35.4095 70.585C35.402 72.1055 35.0315 74.46 35.0315 74.46M46.7577 66.5023H56.0134M46.7577 66.5023C46.7577 66.5023 45.898 64.3031 45.9273 62.835C45.9542 61.4855 46.7577 59.4799 46.7577 59.4799H56.0134M46.7577 66.5023C46.7577 66.5023 45.9103 68.9581 45.9273 70.585C45.9435 72.1326 46.7577 74.46 46.7577 74.46M36.5166 71.969H44.5434M36.7934 53.9779H44.5434M46.7577 74.46H53.0684C54.7805 74.46 56.1684 73.0721 56.1684 71.36V54.31C56.1684 52.5979 54.7805 51.21 53.0684 51.21H35.0315M46.7577 74.46H28.2684C26.5563 74.46 25.1684 73.0721 25.1684 71.36V54.31C25.1684 52.5979 26.5563 51.21 28.2684 51.21H35.0315"
				stroke="#393332"
				stroke-width="0.28"
				stroke-linecap="round"
			/>
			<mask id="mask0_105_6602" maskUnits="userSpaceOnUse" x="0" y="0" width="240" height="153">
				<path
					d="M240 143.408C240 148.166 236.182 152.02 231.464 152.02H8.53575C3.81784 152.02 0 148.166 0 143.408V8.62229C0 3.87416 3.82774 0.0200195 8.53575 0.0200195H231.454C236.172 0.0200195 239.99 3.87416 239.99 8.63223V143.408H240Z"
					fill="#002C50"
				/>
			</mask>
			<g mask="url(#mask0_105_6602)">
				<path
					d="M207.656 52.4335L158.166 66.6235C140.266 71.7535 135.616 63.3735 133.686 56.6335C129.666 42.6135 135.316 34.7935 153.196 29.6735L249.046 2.1935L237.936 -36.5665L136.646 -7.5365C91.6761 5.3535 76.0161 29.7935 87.3661 69.3535C98.0261 106.544 122.916 118.154 165.686 105.883L209.736 93.2535C227.076 88.2835 233.826 90.8135 237.526 103.693C240.596 114.393 238.206 121.354 216.856 127.474L119.786 155.314L130.896 194.064L233.916 164.524C278.716 151.674 294.416 127.654 283.316 88.9335C272.346 50.7435 250.436 40.1635 207.656 52.4335Z"
					fill="#00203F"
				/>
			</g>
			<path
				d="M239.85 143.408V143.548H239.859C239.785 148.165 236.057 151.88 231.464 151.88H8.53575C3.89636 151.88 0.14 148.09 0.14 143.408V8.62229C0.14 3.95049 3.90604 0.16002 8.53575 0.16002H231.454C236.094 0.16002 239.85 3.95027 239.85 8.63223V143.408Z"
				stroke="#706F6F"
				stroke-width="0.28"
			/>
			<path
				d="M229.98 137.58V137.07H230.18V136.97H229.66V137.07H229.86V137.58H229.98ZM230.99 137.58V136.97H230.83L230.65 137.39L230.46 136.97H230.3V137.58H230.41V137.12L230.58 137.52H230.7L230.87 137.12V137.58H230.99Z"
				fill="#FF9E18"
			/>
			<path
				d="M199.99 127.83C199.99 122.81 202.35 118.35 206.01 115.46C203.33 113.35 199.96 112.08 196.28 112.08C187.58 112.08 180.53 119.13 180.53 127.83C180.53 136.53 187.58 143.58 196.28 143.58C199.96 143.58 203.33 142.31 206.01 140.2C202.35 137.31 199.99 132.85 199.99 127.83Z"
				fill="#E30613"
			/>
			<path
				d="M212.02 127.83C212.02 122.81 209.66 118.35 206 115.46C202.34 118.34 199.98 122.81 199.98 127.83C199.98 132.85 202.34 137.31 206 140.2C209.67 137.31 212.02 132.85 212.02 127.83Z"
				fill="#FF671D"
			/>
			<path
				d="M215.74 112.08C212.06 112.08 208.69 113.35 206.01 115.46C209.67 118.34 212.03 122.81 212.03 127.83C212.03 132.85 209.67 137.31 206.01 140.2C208.69 142.31 212.06 143.58 215.74 143.58C224.44 143.58 231.49 136.53 231.49 127.83C231.49 119.13 224.44 112.08 215.74 112.08Z"
				fill="#FF9E18"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_105_6602"
					x1="55.0613"
					y1="73.0761"
					x2="25.1684"
					y2="57.8529"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#807C7A" />
					<stop offset="0.323663" stop-color="#84807E" />
					<stop offset="0.661484" stop-color="#858382" />
					<stop offset="1" stop-color="#ACBBC8" />
				</linearGradient>
			</defs>
		</svg>
	),
	DEBIT_CARD_B2C: ({ height }) => (
		<svg height={height} viewBox="0 0 240 153" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M240 144.058C240 148.816 236.182 152.67 231.464 152.67H8.53575C3.81784 152.67 0 148.816 0 144.058V9.2722C0 4.52406 3.82774 0.669922 8.53575 0.669922H231.454C236.172 0.669922 239.99 4.52406 239.99 9.28213V144.058H240Z"
				fill="#D1EAF2"
			/>
			<path
				d="M20.49 17.76H17.39C16.27 17.76 16.14 17.2 16.14 16.78C16.14 15.9 16.6 15.54 17.72 15.54H23.72V13.11H17.38C14.57 13.11 13.26 14.26 13.26 16.74C13.26 19.07 14.51 20.15 17.18 20.15H19.93C21.02 20.15 21.36 20.41 21.36 21.21C21.36 21.88 21.11 22.24 19.77 22.24H13.7V24.67H20.14C22.94 24.67 24.25 23.54 24.25 21.12C24.26 18.73 23.17 17.76 20.49 17.76Z"
				fill="#002C50"
			/>
			<path
				d="M33.66 13.11L30.39 21.03L27.2 13.11H24.06L29.1 24.67H31.81L36.64 13.11H33.66Z"
				fill="#002C50"
			/>
			<path
				d="M41.48 15.49H45.54V13.11H41.43C37.71 13.11 35.97 15.01 35.97 19.09C35.97 21.2 36.56 22.69 37.76 23.64C38.94 24.59 40.09 24.67 41.37 24.67H45.54V22.29H41.48C39.8 22.29 39.13 21.67 39.06 20.01H45.54V17.63H39.09C39.23 16.17 39.99 15.49 41.48 15.49Z"
				fill="#002C50"
			/>
			<path
				d="M50.91 13.11L46.02 24.67H48.98L49.97 22.02H54.49L55.52 24.67H58.61L53.68 13.11H50.91ZM50.9 19.6L52.21 16.16L53.57 19.6H50.9Z"
				fill="#002C50"
			/>
			<path
				d="M58.06 29.87H14.18C13.88 29.87 13.63 29.62 13.63 29.32V27.42C13.63 27.12 13.88 26.87 14.18 26.87H58.06C58.36 26.87 58.61 27.12 58.61 27.42V29.32C58.61 29.62 58.36 29.87 58.06 29.87Z"
				fill="#00ACC9"
			/>
			<path
				d="M56.1684 54.9599V72.0099C56.1684 73.722 54.7805 75.1099 53.0684 75.1099H46.7577H35.0315H28.2684C26.5563 75.1099 25.1684 73.722 25.1684 72.0099V54.9599C25.1684 53.2478 26.5563 51.8599 28.2684 51.8599H35.0315H53.0684C54.7805 51.8599 56.1684 53.2478 56.1684 54.9599Z"
				fill="url(#paint0_linear_105_6603)"
			/>
			<path
				d="M35.0315 60.1298H25.3234M35.0315 60.1298C35.0315 60.1298 35.397 62.1664 35.4095 63.4849C35.4231 64.9246 35.0315 67.1522 35.0315 67.1522M35.0315 60.1298C35.0315 60.1298 35.4083 57.6267 35.4095 56.0117C35.4107 54.3836 35.0315 51.8599 35.0315 51.8599M35.0315 67.1522H25.3234M35.0315 67.1522C35.0315 67.1522 35.4173 69.6337 35.4095 71.2349C35.402 72.7554 35.0315 75.1099 35.0315 75.1099M46.7577 67.1522H56.0134M46.7577 67.1522C46.7577 67.1522 45.898 64.953 45.9273 63.4849C45.9542 62.1354 46.7577 60.1298 46.7577 60.1298H56.0134M46.7577 67.1522C46.7577 67.1522 45.9103 69.608 45.9273 71.2349C45.9435 72.7825 46.7577 75.1099 46.7577 75.1099M36.5166 72.6189H44.5434M36.7934 54.6278H44.5434M46.7577 75.1099H53.0684C54.7805 75.1099 56.1684 73.722 56.1684 72.0099V54.9599C56.1684 53.2478 54.7805 51.8599 53.0684 51.8599H35.0315M46.7577 75.1099H28.2684C26.5563 75.1099 25.1684 73.722 25.1684 72.0099V54.9599C25.1684 53.2478 26.5563 51.8599 28.2684 51.8599H35.0315"
				stroke="#393332"
				stroke-width="0.28"
				stroke-linecap="round"
			/>
			<mask id="mask0_105_6603" maskUnits="userSpaceOnUse" x="0" y="0" width="240" height="153">
				<path
					d="M240 144.058C240 148.816 236.182 152.67 231.464 152.67H8.53575C3.81784 152.67 0 148.816 0 144.058V9.2722C0 4.52406 3.82774 0.669922 8.53575 0.669922H231.454C236.172 0.669922 239.99 4.52406 239.99 9.28213V144.058H240Z"
					fill="#002C50"
				/>
			</mask>
			<g mask="url(#mask0_105_6603)">
				<path
					d="M207.656 53.0834L158.166 67.2734C140.266 72.4034 135.616 64.0234 133.686 57.2834C129.666 43.2634 135.316 35.4434 153.196 30.3234L249.046 2.84338L237.936 -35.9166L136.646 -6.88662C91.6761 6.00338 76.0161 30.4434 87.3661 70.0034C98.0261 107.193 122.916 118.803 165.686 106.533L209.736 93.9034C227.076 88.9334 233.826 91.4634 237.526 104.343C240.596 115.043 238.206 122.003 216.856 128.123L119.786 155.963L130.896 194.713L233.916 165.173C278.716 152.323 294.416 128.303 283.316 89.5834C272.346 51.3934 250.436 40.8134 207.656 53.0834Z"
					fill="#A6D9E3"
				/>
			</g>
			<path
				d="M239.85 144.058V144.198H239.859C239.785 148.815 236.057 152.53 231.464 152.53H8.53575C3.89636 152.53 0.14 148.74 0.14 144.058V9.2722C0.14 4.60039 3.90604 0.809922 8.53575 0.809922H231.454C236.094 0.809922 239.85 4.60018 239.85 9.28213V144.058Z"
				stroke="#706F6F"
				stroke-width="0.28"
			/>
			<path
				d="M229.98 138.23V137.72H230.18V137.62H229.66V137.72H229.86V138.23H229.98ZM230.99 138.23V137.62H230.83L230.65 138.04L230.46 137.62H230.3V138.23H230.41V137.77L230.58 138.17H230.7L230.87 137.77V138.23H230.99Z"
				fill="#FF9E18"
			/>
			<path
				d="M199.99 128.48C199.99 123.46 202.35 119 206.01 116.11C203.33 114 199.96 112.73 196.28 112.73C187.58 112.73 180.53 119.78 180.53 128.48C180.53 137.18 187.58 144.23 196.28 144.23C199.96 144.23 203.33 142.96 206.01 140.85C202.35 137.96 199.99 133.5 199.99 128.48Z"
				fill="#E30613"
			/>
			<path
				d="M212.02 128.48C212.02 123.46 209.66 119 206 116.11C202.34 118.99 199.98 123.46 199.98 128.48C199.98 133.5 202.34 137.96 206 140.85C209.67 137.96 212.02 133.5 212.02 128.48Z"
				fill="#FF671D"
			/>
			<path
				d="M215.74 112.73C212.06 112.73 208.69 114 206.01 116.11C209.67 118.99 212.03 123.46 212.03 128.48C212.03 133.5 209.67 137.96 206.01 140.85C208.69 142.96 212.06 144.23 215.74 144.23C224.44 144.23 231.49 137.18 231.49 128.48C231.49 119.78 224.44 112.73 215.74 112.73Z"
				fill="#FF9E18"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_105_6603"
					x1="55.0613"
					y1="73.726"
					x2="25.1684"
					y2="58.5028"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#807C7A" />
					<stop offset="0.323663" stop-color="#84807E" />
					<stop offset="0.661484" stop-color="#858382" />
					<stop offset="1" stop-color="#ACBBC8" />
				</linearGradient>
			</defs>
		</svg>
	),

	EDIT: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.299 0.330231C20.7678 0.110798 20.1984 -0.00136257 19.6236 1.24918e-05L19.5956 0.00391752C18.4287 0.0166102 17.3143 0.490391 16.4955 1.32162L16.1674 1.64954C16.1346 1.67313 16.1034 1.6995 16.0745 1.72848C16.0455 1.75746 16.0191 1.78857 15.9955 1.82144L14.0868 3.72944C14.0487 3.75554 14.0131 3.78515 13.9803 3.81789C13.9477 3.85055 13.9182 3.88608 13.8922 3.92398L2.0885 15.7233C2.05406 15.7477 2.02166 15.7751 1.99169 15.8051C1.92209 15.8748 1.86692 15.9574 1.8293 16.0484C1.80914 16.0972 1.79423 16.1479 1.78475 16.1997L0.0235818 23.0638C-0.00884274 23.19 -0.00781497 23.3226 0.0265727 23.4482C0.0609603 23.5739 0.127504 23.6883 0.219668 23.7804C0.311831 23.8725 0.426424 23.9391 0.552144 23.9735C0.677865 24.0078 0.810385 24.0088 0.936626 23.9764L7.83699 22.206C7.96757 22.1714 8.0864 22.1024 8.18101 22.0061L22.6818 7.5106C23.096 7.1052 23.4257 6.62195 23.652 6.08844C23.8782 5.55493 23.9965 4.9819 23.9999 4.40244C24.0034 3.82299 23.8919 3.24845 23.672 2.7123C23.4521 2.17614 23.1282 1.68895 22.7188 1.27867C22.3127 0.872093 21.8302 0.549665 21.299 0.330231ZM2.91926 17.7909L1.78769 22.2021L6.20117 21.0677L2.91926 17.7909ZM7.66052 20.4011L18.5847 9.48102L14.5127 5.41054L3.58379 16.3339L7.66052 20.4011ZM15.5738 4.35003L19.6457 8.42035L20.6767 7.38977L16.6049 3.31943L15.5738 4.35003ZM21.736 6.32732C21.9589 6.08486 22.139 5.80578 22.268 5.50195C22.417 5.15122 22.495 4.77443 22.4976 4.39341C22.5002 4.01239 22.4273 3.63468 22.2832 3.28194C22.139 2.92921 21.9265 2.60861 21.6578 2.33839C21.3907 2.07153 21.0735 1.85997 20.7244 1.71603C20.3753 1.57209 20.0013 1.49851 19.6236 1.49954H19.6026C18.8842 1.50624 18.1955 1.77847 17.668 2.26072L21.736 6.32732Z"
				fill="currentColor"
			/>
		</svg>
	),
	EXTERNAL_LINK: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.2507 0.624924C11.2507 0.348781 11.4746 0.124924 11.7507 0.124924H16.2507C16.5269 0.124924 16.7507 0.348781 16.7507 0.624924V5.12492C16.7507 5.40107 16.5269 5.62492 16.2507 5.62492C15.9746 5.62492 15.7507 5.40107 15.7507 5.12492V1.83203L6.60429 10.9785C6.40902 11.1737 6.09244 11.1737 5.89718 10.9785C5.70192 10.7832 5.70192 10.4666 5.89718 10.2714L15.0436 1.12492H11.7507C11.4746 1.12492 11.2507 0.901066 11.2507 0.624924ZM0.750732 4.62492C0.750732 3.79689 1.42172 3.12492 2.25073 3.12492H8.25073C8.52687 3.12492 8.75073 3.34878 8.75073 3.62492C8.75073 3.90107 8.52687 4.12492 8.25073 4.12492H2.25073C1.97439 4.12492 1.75073 4.34879 1.75073 4.62492V14.6249C1.75073 14.9011 1.97439 15.1249 2.25073 15.1249H12.2507C12.5266 15.1249 12.7507 14.9008 12.7507 14.6249V8.62492C12.7507 8.34878 12.9746 8.12492 13.2507 8.12492C13.5269 8.12492 13.7507 8.34878 13.7507 8.62492V14.6249C13.7507 15.4532 13.0788 16.1249 12.2507 16.1249H2.25073C1.42173 16.1249 0.750732 15.453 0.750732 14.6249V4.62492Z"
			/>
		</svg>
	),
	INFO: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M11.6256 8.24999C11.4031 8.24999 11.1856 8.18403 11.0006 8.06042C10.8156 7.9368 10.6714 7.7611 10.5862 7.55554C10.5011 7.34997 10.4788 7.12374 10.5222 6.90551C10.5656 6.68728 10.6728 6.48679 10.8301 6.32946C10.9874 6.17213 11.1879 6.06501 11.4061 6.0216C11.6243 5.97819 11.8505 6.00054 12.0561 6.08569C12.2617 6.17084 12.4374 6.31499 12.561 6.49999C12.6846 6.685 12.7506 6.90249 12.7506 7.12499C12.7503 7.42328 12.6317 7.70924 12.4208 7.92016C12.2099 8.13108 11.9239 8.24973 11.6256 8.24999Z"
				fill="currentColor"
			/>
			<path d="M14.2506 17.25H13.5006C12.9041 17.2492 12.3322 17.0119 11.9105 16.5901C11.4887 16.1683 11.2514 15.5965 11.2506 15V11.25H10.5006C10.3017 11.25 10.1109 11.1709 9.97025 11.0303C9.82959 10.8896 9.75058 10.6989 9.75058 10.5C9.75058 10.3011 9.82959 10.1104 9.97025 9.96973C10.1109 9.82907 10.3017 9.75 10.5006 9.75H11.2506C11.6484 9.75 12.0299 9.90803 12.3112 10.1893C12.5926 10.4706 12.7506 10.8522 12.7506 11.25V15C12.7508 15.1988 12.83 15.3894 12.9706 15.53C13.1111 15.6706 13.3017 15.7497 13.5006 15.75H14.2506C14.4495 15.75 14.6403 15.8291 14.7809 15.9697C14.9216 16.1104 15.0006 16.3011 15.0006 16.5C15.0006 16.6989 14.9216 16.8896 14.7809 17.0303C14.6403 17.1709 14.4495 17.25 14.2506 17.25Z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.38774 21.2765C6.53391 23.0377 9.22432 24.0001 12.0006 24C13.5771 24.0042 15.1387 23.6958 16.5951 23.0924C18.0516 22.4891 19.3739 21.6028 20.4856 20.485C22.4486 18.5218 23.6702 15.9387 23.9423 13.1758C24.2143 10.4129 23.5199 7.64111 21.9774 5.33278C20.4349 3.02445 18.1398 1.32242 15.483 0.516615C12.8263 -0.289192 9.97229 -0.148948 7.40739 0.913587C4.8425 1.97612 2.72535 3.89513 1.41673 6.34364C0.108109 8.79215 -0.311045 11.6187 0.230696 14.3416C0.772438 17.0645 2.24157 19.5154 4.38774 21.2765ZM6.1671 3.26954C7.89381 2.11579 9.92389 1.50001 12.0006 1.50001C14.7844 1.50319 17.4533 2.61043 19.4217 4.57887C21.3901 6.54731 22.4974 9.21622 22.5006 12C22.5006 14.0767 21.8848 16.1068 20.731 17.8335C19.5773 19.5602 17.9374 20.906 16.0188 21.7007C14.1001 22.4954 11.9889 22.7034 9.95213 22.2982C7.91533 21.8931 6.04442 20.893 4.57597 19.4246C3.10752 17.9561 2.10749 16.0853 1.70235 14.0485C1.2972 12.0117 1.50513 9.90045 2.29985 7.98182C3.09457 6.0632 4.44038 4.4233 6.1671 3.26954Z"
			/>
		</svg>
	),
	LINK_ARROW: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path
				d="M19.5001 7.99658H19.5H19.4994C19.4497 7.99663 19.4015 8.01134 19.3607 8.03864C19.3196 8.06614 19.2876 8.10514 19.2687 8.15075C19.2498 8.19643 19.2448 8.24671 19.2545 8.29515C19.2641 8.34346 19.2877 8.38786 19.3226 8.42283C19.3226 8.4229 19.3227 8.42297 19.3228 8.42303L21.7926 10.893L22.6461 11.7466H21.439H0.75C0.68379 11.7466 0.620169 11.7729 0.573219 11.8199C0.526312 11.8668 0.5 11.9303 0.5 11.9966C0.5 12.0629 0.526312 12.1264 0.573219 12.1733C0.620169 12.2203 0.68379 12.2466 0.75 12.2466H21.439H22.6461L21.7926 13.1001L19.3226 15.5703L19.3225 15.5704C19.2755 15.6174 19.2493 15.6808 19.2493 15.7471C19.2493 15.8133 19.2755 15.8768 19.3225 15.9238C19.37 15.9713 19.4339 15.9976 19.4995 15.9976C19.5651 15.9976 19.6289 15.9713 19.6764 15.9238L23.4264 12.1738L23.4266 12.1737C23.4501 12.1501 23.4684 12.1227 23.4808 12.0928C23.484 12.085 23.4868 12.0771 23.4892 12.0691L23.4893 12.0688C23.4963 12.0456 23.5 12.0213 23.5 11.9966C23.5 11.9303 23.4737 11.8668 23.4268 11.8199L19.5001 7.99658ZM19.5001 7.99658C19.5328 7.99657 19.5652 8.00302 19.5952 8.01551C19.6248 8.02777 19.6523 8.04613 19.6758 8.06974L19.6764 8.07035L23.4055 11.7994L23.4124 11.8063L23.4196 11.813L23.4268 11.8199L19.5001 7.99658ZM23.968 12.2132C23.9608 12.2373 23.9524 12.2609 23.9427 12.2842L23.968 12.2132ZM23.968 12.2132C23.989 12.1436 24 12.0707 24 11.9966M23.968 12.2132L24 11.9966M24 11.9966C24 11.7977 23.921 11.607 23.7803 11.4663M24 11.9966L23.7803 11.4663M23.7803 11.4663C23.7733 11.4593 23.7662 11.4525 23.759 11.4458L23.7803 11.4663Z"
				fill="currentColor"
				stroke="currentColor"
			/>
		</svg>
	),
	LIST_CHECK: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.5955 15.992C10.7776 16.0671 10.9727 16.1056 11.1697 16.1053H11.2766C11.4905 16.0888 11.6985 16.0266 11.8865 15.9232C12.0746 15.8197 12.2383 15.6772 12.3668 15.5052L16.3449 10.1983C16.4642 10.0392 16.5154 9.83908 16.4873 9.64219C16.4592 9.4453 16.354 9.26744 16.195 9.14811C16.036 9.02877 15.8361 8.97742 15.6393 9.00555C15.4426 9.03367 15.265 9.13888 15.1458 9.29799L11.1677 14.6054L8.78044 12.218C8.71127 12.1465 8.62854 12.0894 8.53709 12.0501C8.44563 12.0108 8.34729 11.9899 8.24778 11.9891C8.14827 11.9882 8.04958 12.0075 7.95749 12.0452C7.86541 12.083 7.78176 12.1388 7.71143 12.2093C7.64109 12.2797 7.58549 12.3631 7.54785 12.4553C7.51021 12.5475 7.49129 12.6462 7.4922 12.7458C7.49311 12.8454 7.51384 12.9439 7.55316 13.0353C7.59248 13.1268 7.6496 13.2093 7.72122 13.2785L10.1085 15.6673C10.2479 15.8065 10.4134 15.9168 10.5955 15.992Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.0248 0.232404C12.7043 0.0788924 12.3534 -0.000421065 11.9981 1.06776e-05C11.6425 -0.00105772 11.2912 0.0780648 10.9703 0.231428C10.6494 0.384791 10.3671 0.608686 10.1444 0.886133L8.63355 2.75651C8.54136 2.87202 8.42145 2.96253 8.28499 3.01917C8.14853 3.07582 7.99995 3.09697 7.85311 3.08069L5.45487 2.81949C5.36758 2.81021 5.27985 2.80586 5.19207 2.80582C4.85775 2.80575 4.52719 2.87589 4.22195 3.01234C3.91671 3.14878 3.64365 3.34851 3.42063 3.59771C3.1976 3.84692 3.02962 4.14036 2.92764 4.45894C2.82566 4.77751 2.79199 5.11364 2.8288 5.44612L3.0896 7.84622C3.10579 7.99299 3.08461 8.14144 3.028 8.2778C2.97139 8.41417 2.88119 8.53381 2.76583 8.62591L0.888206 10.1379C0.610959 10.3608 0.387227 10.6431 0.233502 10.964C0.0797781 11.2849 0 11.6363 0 11.9922C0 12.3481 0.0797781 12.6995 0.233502 13.0204C0.387227 13.3413 0.610959 13.6235 0.888206 13.8465L2.76583 15.356C2.88132 15.4485 2.97163 15.5689 3.02839 15.7056C3.08516 15.8423 3.10656 15.991 3.09061 16.1382L2.82978 18.5378C2.7894 18.8926 2.82947 19.2518 2.947 19.5889C3.06454 19.9261 3.25652 20.2326 3.50867 20.4853C3.76081 20.738 4.06666 20.9306 4.40343 21.0487C4.7402 21.1668 5.09924 21.2072 5.45387 21.1673L7.85211 20.9066C7.8853 20.9031 7.91866 20.901 7.95204 20.9013C8.08374 20.9012 8.21376 20.931 8.33244 20.9882C8.45112 21.0453 8.5554 21.1283 8.63754 21.2313L10.1475 23.1109C10.3702 23.3884 10.6524 23.6123 10.9731 23.7661C11.2938 23.92 11.6449 24 12.0006 24C12.3563 24 12.7074 23.92 13.0281 23.7661C13.3488 23.6123 13.631 23.3884 13.8537 23.1109L15.3596 21.2362C15.4515 21.1206 15.5713 21.0307 15.7076 20.974C15.8439 20.9173 15.9923 20.8961 16.139 20.9125L18.5373 21.1732C18.6246 21.1825 18.7123 21.1873 18.8001 21.1874C19.1344 21.1874 19.465 21.1168 19.7702 20.9804C20.0755 20.8439 20.3485 20.6447 20.5716 20.3955C20.7946 20.1463 20.9626 19.8528 21.0646 19.5342C21.1665 19.2157 21.2002 18.8791 21.1634 18.5466L20.9026 16.147C20.8862 16.0004 20.9072 15.8522 20.9634 15.7159C21.0197 15.5795 21.1094 15.4596 21.2243 15.3673L23.113 13.8601C23.3899 13.637 23.6133 13.3549 23.7668 13.0341C23.9203 12.7132 24 12.3616 24 12.0059C24 11.6501 23.9203 11.299 23.7668 10.9782C23.6133 10.6573 23.3899 10.3747 23.113 10.1516L21.2323 8.64007C21.117 8.54797 21.0268 8.42784 20.9702 8.29147C20.9136 8.15511 20.8924 8.00666 20.9086 7.85989L21.1694 5.46028C21.2061 5.12761 21.1722 4.79081 21.07 4.47212C20.9679 4.15342 20.7997 3.86017 20.5765 3.6109C20.3533 3.36162 20.0801 3.16201 19.7747 3.02552C19.4693 2.88903 19.1386 2.81846 18.8041 2.81851C18.7173 2.8185 18.6306 2.82334 18.5443 2.83267L16.1461 3.09387C16.1129 3.09742 16.0795 3.09897 16.0461 3.09875C15.9146 3.09882 15.7847 3.06898 15.6662 3.01185C15.5477 2.95472 15.4436 2.87169 15.3616 2.76871L13.8497 0.887109C13.6272 0.609908 13.3453 0.385916 13.0248 0.232404ZM15.0184 4.36617C15.3394 4.52044 15.6911 4.6003 16.0471 4.59954C16.1322 4.59977 16.2173 4.59524 16.302 4.58636L18.7002 4.32565C18.7334 4.32216 18.7668 4.32012 18.8001 4.32028C18.924 4.32022 19.0466 4.34636 19.1597 4.39693C19.2728 4.44751 19.374 4.52179 19.4566 4.61419C19.5393 4.70659 19.6015 4.81538 19.6392 4.93349C19.6769 5.05159 19.6892 5.17595 19.6755 5.29917L19.4147 7.69926C19.3706 8.09658 19.4277 8.49832 19.5807 8.86758C19.7338 9.23683 19.9778 9.56139 20.29 9.81082L22.1687 11.3219C22.2709 11.4043 22.3533 11.5085 22.4099 11.627C22.4666 11.7455 22.496 11.875 22.496 12.0064C22.496 12.1377 22.4666 12.2677 22.4099 12.3862C22.3533 12.5047 22.2709 12.6089 22.1687 12.6913L20.281 14.1985C19.969 14.4482 19.7251 14.7728 19.572 15.1422C19.419 15.5116 19.3618 15.9136 19.4057 16.311L19.6665 18.7106C19.6803 18.8336 19.6679 18.9579 19.6303 19.0758C19.5927 19.1937 19.5307 19.3024 19.4482 19.3946C19.3658 19.4868 19.2648 19.5609 19.152 19.6114C19.0391 19.6619 18.9168 19.6876 18.7931 19.6875C18.7597 19.6878 18.7264 19.6863 18.6932 19.6827L16.2949 19.4215C15.8979 19.3778 15.4963 19.4353 15.1273 19.5884C14.7584 19.7416 14.4341 19.9853 14.1845 20.2973L12.6806 22.1701C12.5983 22.2728 12.494 22.3559 12.3754 22.4128C12.2569 22.4697 12.1271 22.4992 11.9956 22.4992C11.8641 22.4992 11.7343 22.4697 11.6157 22.4128C11.4972 22.3559 11.3929 22.2728 11.3106 22.1701L9.8007 20.2905C9.55099 19.9786 9.22667 19.7347 8.85775 19.5816C8.48884 19.4285 8.08726 19.3711 7.69024 19.4146L5.292 19.6758C5.25882 19.6795 5.22544 19.681 5.19207 19.6807C5.06842 19.6807 4.94618 19.6543 4.83338 19.6036C4.72059 19.5529 4.6198 19.4788 4.53767 19.3863C4.45553 19.2938 4.39391 19.185 4.35686 19.067C4.31981 18.949 4.30817 18.8247 4.32271 18.7018L4.5835 16.3022C4.62723 15.9048 4.56994 15.5028 4.41691 15.1334C4.26388 14.7641 4.02009 14.4391 3.70817 14.1892L1.82953 12.6786C1.72699 12.5963 1.64424 12.4916 1.58737 12.373C1.53051 12.2544 1.50098 12.1247 1.50098 11.9932C1.50098 11.8616 1.53051 11.7315 1.58737 11.6128C1.64424 11.4942 1.72699 11.3901 1.82953 11.3077L3.70716 9.79568C4.01944 9.54632 4.2635 9.2222 4.41657 8.85293C4.56964 8.48366 4.62674 8.08145 4.58253 7.68413L4.3217 5.28452C4.30791 5.16156 4.32023 5.03671 4.35784 4.91884C4.39544 4.80098 4.45751 4.69273 4.53995 4.60052C4.6224 4.50831 4.72335 4.43423 4.83625 4.38375C4.94914 4.33327 5.0714 4.30752 5.19505 4.30759C5.22843 4.30732 5.2618 4.30887 5.29499 4.31247L7.69323 4.57367C8.08991 4.61721 8.49117 4.55993 8.85989 4.40719C9.2286 4.25444 9.55288 4.01113 9.80271 3.69975L11.3136 1.82889C11.3961 1.72661 11.5004 1.6439 11.619 1.58722C11.7375 1.53054 11.8672 1.50129 11.9986 1.50129C12.13 1.50129 12.2597 1.53054 12.3782 1.58722C12.4967 1.6439 12.6011 1.72661 12.6836 1.82889L14.1935 3.70854C14.4155 3.98712 14.6975 4.21191 15.0184 4.36617Z"
				fill="currentColor"
			/>
		</svg>
	),
	LOCKED: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.64644 12.3535C7.74021 12.4473 7.86739 12.5 8 12.5C8.13261 12.5 8.25979 12.4473 8.35356 12.3535C8.44732 12.2597 8.5 12.1326 8.5 12V10C8.5 9.86739 8.44732 9.74025 8.35356 9.64648C8.25979 9.55272 8.13261 9.5 8 9.5C7.86739 9.5 7.74021 9.55272 7.64644 9.64648C7.55268 9.74025 7.5 9.86739 7.5 10V12C7.5 12.1326 7.55268 12.2597 7.64644 12.3535Z"
				fill="#406D0D"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4 4V6H3.5C3.10234 6.00053 2.72109 6.15875 2.4399 6.43994C2.15871 6.72113 2.00053 7.10234 2 7.5V14.5C2.00053 14.8977 2.15871 15.2789 2.4399 15.5601C2.72109 15.8412 3.10234 15.9995 3.5 16H12.5C12.8977 15.9995 13.2789 15.8412 13.5601 15.5601C13.8412 15.2789 13.9995 14.8977 14 14.5V7.5C13.9995 7.10234 13.8412 6.72113 13.5601 6.43994C13.2789 6.15875 12.8977 6.00053 12.5 6H12V4C12 2.93913 11.5786 1.9217 10.8284 1.17155C10.0783 0.421404 9.06087 0 8 0C6.93913 0 5.9217 0.421404 5.17155 1.17155C4.4214 1.9217 4 2.93913 4 4ZM3.14665 7.14665C3.24038 7.05292 3.36745 7.00018 3.5 7H12.5C12.6326 7.00018 12.7596 7.05292 12.8534 7.14665C12.9471 7.24038 12.9998 7.36745 13 7.5V14.5C12.9998 14.6326 12.9471 14.7596 12.8534 14.8534C12.7596 14.9471 12.6326 14.9998 12.5 15H3.5C3.36745 14.9998 3.24038 14.9471 3.14665 14.8534C3.05292 14.7596 3.00018 14.6326 3 14.5V7.5C3.00018 7.36745 3.05292 7.24038 3.14665 7.14665ZM11 4V6H5V4C5 3.20435 5.31605 2.44127 5.87866 1.87866C6.44127 1.31605 7.20435 1 8 1C8.79565 1 9.55869 1.31605 10.1213 1.87866C10.6839 2.44127 11 3.20435 11 4Z"
				fill="#406D0D"
			/>
		</svg>
	),
	LOGOUT: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.0004 21.146C8.71577 22.2172 10.6982 22.7837 12.7206 22.7806C14.6284 22.7803 16.5021 22.2748 18.1502 21.3136C19.7983 20.3525 21.1618 18.9712 22.1016 17.3108C23.0413 15.6504 23.5235 13.7704 23.4991 11.8627C23.4747 9.95497 22.9444 8.0879 21.9625 6.45212C20.9805 4.81634 19.5821 3.47042 17.9099 2.55182C16.2377 1.63323 14.3517 1.17485 12.4445 1.22347C10.5372 1.2721 8.67701 1.826 7.05381 2.82861C5.43061 3.83122 4.10257 5.24661 3.20525 6.93031C3.1582 7.01372 3.12828 7.10571 3.11729 7.20084C3.10629 7.29598 3.11444 7.39233 3.14123 7.48427C3.16802 7.57621 3.21291 7.6619 3.27328 7.73624C3.33365 7.81058 3.40826 7.87209 3.49275 7.91717C3.57723 7.96226 3.6699 7.99 3.76527 7.99876C3.86063 8.00753 3.95679 7.99715 4.04808 7.96821C4.13937 7.93928 4.22396 7.89238 4.29686 7.83029C4.36977 7.76819 4.42953 7.69214 4.47262 7.60662C5.46076 5.75617 7.04301 4.29222 8.96451 3.45055C10.886 2.60887 13.0349 2.43849 15.065 2.96683C17.0951 3.49518 18.8883 4.6915 20.1557 6.3631C21.4231 8.0347 22.091 10.0843 22.0517 12.1816C22.0124 14.279 21.2683 16.3021 19.9391 17.9251C18.61 19.548 16.7733 20.6764 14.7248 21.1283C12.6763 21.5803 10.5353 21.3295 8.64667 20.4164C6.75805 19.5034 5.23173 17.9812 4.31359 16.095C4.23025 15.9237 4.08227 15.7924 3.90217 15.7302C3.72207 15.6679 3.52461 15.6798 3.35324 15.7631C3.18187 15.8464 3.05064 15.9944 2.98839 16.1745C2.92615 16.3546 2.93798 16.5521 3.02131 16.7234C3.90602 18.542 5.28502 20.0748 7.0004 21.146Z"
				fill="currentColor"
			/>
			<path
				d="M12.7139 16.3125C12.5719 16.3123 12.4331 16.2701 12.315 16.1912C12.197 16.1122 12.105 16.0001 12.0507 15.8689C11.9964 15.7377 11.9821 15.5933 12.0098 15.454C12.0375 15.3147 12.1058 15.1868 12.2062 15.0863L14.5685 12.724H1.21846C1.02791 12.724 0.845167 12.6483 0.710429 12.5136C0.575691 12.3788 0.5 12.1961 0.5 12.0055C0.5 11.815 0.575691 11.6322 0.710429 11.4975C0.845167 11.3628 1.02791 11.2871 1.21846 11.2871H14.5762L12.2062 8.91709C12.0714 8.78231 11.9956 8.59952 11.9956 8.40891C11.9956 8.2183 12.0714 8.03548 12.2062 7.9007C12.3409 7.76592 12.5237 7.69021 12.7143 7.69021C12.905 7.69021 13.0878 7.76592 13.2226 7.9007L16.8149 11.493C16.8816 11.5597 16.9346 11.639 16.9707 11.7262C17.0069 11.8134 17.0254 11.9068 17.0254 12.0012C17.0254 12.0456 17.0213 12.0899 17.0132 12.1333C16.9873 12.2764 16.9184 12.4093 16.8142 12.5136C16.8001 12.5277 16.7854 12.5413 16.7702 12.5541L13.2226 16.1017C13.1559 16.1687 13.0766 16.2217 12.9893 16.2579C12.902 16.2941 12.8084 16.3126 12.7139 16.3125Z"
				fill="currentColor"
			/>
		</svg>
	),
	MINUSWITHCIRCLE: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0.255 0.126 16 16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M 0.255 8.126 C 0.255 3.708 3.837 0.126 8.255 0.126 C 12.673 0.126 16.255 3.708 16.255 8.126 C 16.255 12.544 12.673 16.126 8.255 16.126 C 3.837 16.126 0.255 12.544 0.255 8.126 Z M 8.255 1.126 C 4.389 1.126 1.255 4.26 1.255 8.126 C 1.255 11.992 4.389 15.126 8.255 15.126 C 12.121 15.126 15.255 11.992 15.255 8.126 C 15.255 4.26 12.121 1.126 8.255 1.126 Z M 7.758 7.626 L 8.758 7.626 L 11.255 7.626 C 11.531 7.626 11.755 7.85 11.755 8.126 C 11.755 8.402 11.531 8.626 11.255 8.626 L 8.758 8.626 L 7.758 8.626 L 5.255 8.626 C 4.979 8.626 4.755 8.402 4.755 8.126 C 4.755 7.85 4.979 7.626 5.255 7.626 L 7.758 7.626 Z"
				fill="currentColor"
			/>
		</svg>
	),
	PLUSWITHCIRCLE: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 8C0 3.58193 3.58185 0 8 0C12.4181 0 16 3.58193 16 8C16 12.4181 12.4181 16 8 16C3.58185 16 0 12.4181 0 8ZM8 1C4.13414 1 1 4.13421 1 8C1 11.8658 4.13414 15 8 15C11.8658 15 15 11.8658 15 8C15 4.13421 11.8658 1 8 1ZM8.00333 4.5C8.27948 4.5 8.50333 4.72386 8.50333 5V7.5H11C11.2761 7.5 11.5 7.72386 11.5 8C11.5 8.27614 11.2761 8.5 11 8.5H8.50333V11C8.50333 11.2761 8.27948 11.5 8.00333 11.5C7.72719 11.5 7.50333 11.2761 7.50333 11V8.5H5C4.72386 8.5 4.5 8.27614 4.5 8C4.5 7.72386 4.72386 7.5 5 7.5H7.50333V5C7.50333 4.72386 7.72719 4.5 8.00333 4.5Z"
				fill="currentColor"
			/>
		</svg>
	),
	PRIVATE_USER: ({ color, height }) => (
		<svg
			viewBox="0 0 21 24"
			height={height}
			color={color}
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.09268 10.8755C8.0692 11.528 9.21729 11.8763 10.3917 11.8763C11.9661 11.8745 13.4754 11.2482 14.5886 10.1349C15.7019 9.02171 16.3281 7.5125 16.3299 5.93817C16.3299 4.76372 15.9816 3.61556 15.3291 2.63904C14.6767 1.66252 13.7492 0.901548 12.6642 0.452104C11.5791 0.00265968 10.3852 -0.115052 9.23328 0.114072C8.0814 0.343197 7.02334 0.908769 6.19287 1.73923C5.36241 2.5697 4.79684 3.6277 4.56771 4.77958C4.33859 5.93147 4.45618 7.12559 4.90562 8.21064C5.35507 9.29569 6.11616 10.223 7.09268 10.8755ZM7.91746 2.23504C8.64985 1.74568 9.51091 1.48456 10.3917 1.48456C11.5725 1.48587 12.7046 1.95561 13.5395 2.79054C14.3744 3.62547 14.844 4.7574 14.8454 5.93817C14.8454 6.81901 14.5842 7.68 14.0948 8.4124C13.6054 9.14479 12.9098 9.7157 12.096 10.0528C11.2823 10.3899 10.3868 10.4781 9.52287 10.3062C8.65895 10.1344 7.86539 9.7101 7.24255 9.08725C6.6197 8.4644 6.19558 7.67096 6.02374 6.80705C5.85189 5.94313 5.94006 5.04755 6.27714 4.23376C6.61422 3.41997 7.18507 2.72441 7.91746 2.23504Z"
				fill="currentColor"
			/>
			<path
				d="M19.5164 23.7825C19.6556 23.9217 19.8444 24 20.0412 24C20.2381 24 20.4269 23.9217 20.5661 23.7825C20.7053 23.6433 20.7835 23.4546 20.7835 23.2577C20.7835 20.5017 19.6887 17.8585 17.7398 15.9097C15.791 13.9609 13.1478 12.866 10.3918 12.866C7.63569 12.866 4.9925 13.9609 3.04367 15.9097C1.09484 17.8585 0 20.5017 0 23.2577C0 23.4546 0.0781987 23.6433 0.217401 23.7825C0.356603 23.9217 0.545406 24 0.742268 24C0.93913 24 1.12793 23.9217 1.26714 23.7825C1.40634 23.6433 1.48454 23.4546 1.48454 23.2577C1.48454 20.8954 2.42298 18.6298 4.09341 16.9593C5.76383 15.2889 8.02941 14.3505 10.3918 14.3505C12.7541 14.3505 15.0197 15.2889 16.6901 16.9593C18.3605 18.6298 19.299 20.8954 19.299 23.2577C19.299 23.4546 19.3772 23.6433 19.5164 23.7825Z"
				fill="currentColor"
			/>
		</svg>
	),
	QUESTIONMARK: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.9972 22.75C17.9342 22.75 22.7472 17.9371 22.7472 12C22.7472 6.06294 17.9342 1.25 11.9972 1.25C6.06009 1.25 1.24715 6.06294 1.24715 12C1.24715 17.9371 6.06009 22.75 11.9972 22.75Z"
				fill="#00699A"
			/>
			<path d="M12.0254 14.4404C11.4805 14.4404 11.2432 14.0361 11.2432 13.5352V13.2891C11.2432 12.1025 11.7969 11.3203 13.001 10.5996C14.0205 9.97559 14.416 9.4043 14.416 8.50781C14.416 7.36523 13.5547 6.5918 12.2627 6.5918C11.0938 6.5918 10.3203 7.18066 10.0303 8.23535C9.88086 8.77148 9.6875 8.93848 9.29199 8.93848C8.84375 8.93848 8.59766 8.6748 8.59766 8.21777C8.59766 7.83984 8.66797 7.54102 8.82617 7.19824C9.34473 5.9502 10.6367 5.2207 12.3242 5.2207C14.5039 5.2207 16.0508 6.54785 16.0508 8.42871C16.0508 9.80859 15.3389 10.7578 14.2139 11.4346C13.0977 12.0938 12.7812 12.5859 12.7812 13.5088C12.7812 14.0625 12.5703 14.4404 12.0254 14.4404ZM12.0166 18.0879C11.4541 18.0879 11.0146 17.6484 11.0146 17.0859C11.0146 16.5146 11.4541 16.084 12.0166 16.084C12.5879 16.084 13.0186 16.5146 13.0186 17.0859C13.0186 17.6484 12.5879 18.0879 12.0166 18.0879Z" />
		</svg>
	),
	RADIO_CHECKED: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 20 20"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="10" cy="10" r="10" fill="currentColor" />
			<path
				d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z"
				fill="white"
			/>
			<circle cx="10" cy="10" r="6" fill="currentColor" />
		</svg>
	),
	RADIO_UNCHECKED: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 20 20"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="10" cy="10" r="10" fill="currentColor" />
			<path
				d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z"
				fill="white"
			/>
		</svg>
	),
	SEARCH: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.1119 18.7134C7.97751 18.7139 5.91909 17.9219 4.33586 16.4911C2.75263 15.0603 1.75747 13.0928 1.54343 10.97C1.32938 8.84722 1.9117 6.72063 3.17744 5.00277C4.44318 3.2849 6.30212 2.09807 8.39362 1.67276C10.4851 1.24745 12.6601 1.61386 14.4966 2.70086C16.3332 3.78787 17.7004 5.51797 18.333 7.55562C18.9656 9.59328 18.8186 11.7933 17.9204 13.7288C17.5959 14.4281 17.1817 15.0748 16.6922 15.655L22.288 21.2495C22.3903 21.3519 22.46 21.4823 22.4882 21.6242C22.5164 21.7661 22.5019 21.9133 22.4465 22.047C22.3911 22.1807 22.2973 22.2949 22.177 22.3754C22.0567 22.4558 21.9152 22.4987 21.7705 22.4988L21.7695 22.5C21.6733 22.5 21.5781 22.4808 21.4893 22.444C21.4005 22.4071 21.3198 22.3531 21.2519 22.285L15.6558 16.6903C15.0041 17.2389 14.2693 17.6921 13.4721 18.0301C12.4093 18.4814 11.2665 18.7137 10.1119 18.7134ZM17.0432 11.7936C16.7427 13.0347 16.1157 14.1677 15.2335 15.0783C15.2043 15.0998 15.1766 15.1236 15.1507 15.1496C15.1245 15.1758 15.1005 15.2037 15.0788 15.2332C14.9483 15.3599 14.8126 15.4819 14.672 15.5988C13.4931 16.5796 12.0295 17.1544 10.4981 17.2385C8.96667 17.3225 7.44888 16.9111 6.16969 16.0652C4.89051 15.2193 3.91799 13.9841 3.39624 12.5424C2.87448 11.1007 2.83126 9.52929 3.27298 8.06109C3.71471 6.5929 4.61789 5.30586 5.84865 4.39101C7.07941 3.47615 8.57227 2.98205 10.106 2.98184L10.1031 2.98279C11.5053 2.97618 12.878 3.38518 14.0477 4.15817C15.2175 4.93116 16.1317 6.03342 16.675 7.32565C17.2748 8.7367 17.4039 10.3035 17.0432 11.7936Z"
				fill="currentColor"
			/>
		</svg>
	),
	SIGN_DONE: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.5955 15.992C10.7776 16.0671 10.9727 16.1056 11.1697 16.1053H11.2766C11.4905 16.0888 11.6985 16.0266 11.8865 15.9232C12.0746 15.8197 12.2383 15.6772 12.3668 15.5052L16.3449 10.1983C16.4642 10.0392 16.5154 9.83908 16.4873 9.64219C16.4592 9.4453 16.354 9.26744 16.195 9.14811C16.036 9.02877 15.8361 8.97742 15.6393 9.00555C15.4426 9.03367 15.265 9.13888 15.1458 9.29799L11.1677 14.6054L8.78044 12.218C8.71127 12.1465 8.62854 12.0894 8.53709 12.0501C8.44563 12.0108 8.34729 11.9899 8.24778 11.9891C8.14827 11.9882 8.04958 12.0075 7.95749 12.0452C7.86541 12.083 7.78176 12.1388 7.71143 12.2093C7.64109 12.2797 7.58549 12.3631 7.54785 12.4553C7.51021 12.5475 7.49129 12.6462 7.4922 12.7458C7.49311 12.8454 7.51384 12.9439 7.55316 13.0353C7.59248 13.1268 7.6496 13.2093 7.72122 13.2785L10.1085 15.6673C10.2479 15.8065 10.4134 15.9168 10.5955 15.992Z"
				fill="#406D0D"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.0248 0.232404C12.7043 0.0788924 12.3534 -0.000421065 11.9981 1.06776e-05C11.6425 -0.00105772 11.2912 0.0780648 10.9703 0.231428C10.6494 0.384791 10.3671 0.608686 10.1444 0.886133L8.63355 2.75651C8.54136 2.87202 8.42145 2.96253 8.28499 3.01917C8.14853 3.07582 7.99995 3.09697 7.85311 3.08069L5.45487 2.81949C5.36758 2.81021 5.27985 2.80586 5.19207 2.80582C4.85775 2.80575 4.52719 2.87589 4.22195 3.01234C3.91671 3.14878 3.64365 3.34851 3.42063 3.59771C3.1976 3.84692 3.02962 4.14036 2.92764 4.45894C2.82566 4.77751 2.79199 5.11364 2.8288 5.44612L3.0896 7.84622C3.10579 7.99299 3.08461 8.14144 3.028 8.2778C2.97139 8.41417 2.88119 8.53381 2.76583 8.62591L0.888206 10.1379C0.610959 10.3608 0.387227 10.6431 0.233502 10.964C0.0797781 11.2849 0 11.6363 0 11.9922C0 12.3481 0.0797781 12.6995 0.233502 13.0204C0.387227 13.3413 0.610959 13.6235 0.888206 13.8465L2.76583 15.356C2.88132 15.4485 2.97163 15.5689 3.02839 15.7056C3.08516 15.8423 3.10656 15.991 3.09061 16.1382L2.82978 18.5378C2.7894 18.8926 2.82947 19.2518 2.947 19.5889C3.06454 19.9261 3.25652 20.2326 3.50867 20.4853C3.76081 20.738 4.06666 20.9306 4.40343 21.0487C4.7402 21.1668 5.09924 21.2072 5.45387 21.1673L7.85211 20.9066C7.8853 20.9031 7.91866 20.901 7.95204 20.9013C8.08374 20.9012 8.21376 20.931 8.33244 20.9882C8.45112 21.0453 8.5554 21.1283 8.63754 21.2313L10.1475 23.1109C10.3702 23.3884 10.6524 23.6123 10.9731 23.7661C11.2938 23.92 11.6449 24 12.0006 24C12.3563 24 12.7074 23.92 13.0281 23.7661C13.3488 23.6123 13.631 23.3884 13.8537 23.1109L15.3596 21.2362C15.4515 21.1206 15.5713 21.0307 15.7076 20.974C15.8439 20.9173 15.9923 20.8961 16.139 20.9125L18.5373 21.1732C18.6246 21.1825 18.7123 21.1873 18.8001 21.1874C19.1344 21.1874 19.465 21.1168 19.7702 20.9804C20.0755 20.8439 20.3485 20.6447 20.5716 20.3955C20.7946 20.1463 20.9626 19.8528 21.0646 19.5342C21.1665 19.2157 21.2002 18.8791 21.1634 18.5466L20.9026 16.147C20.8862 16.0004 20.9072 15.8522 20.9634 15.7159C21.0197 15.5795 21.1094 15.4596 21.2243 15.3673L23.113 13.8601C23.3899 13.637 23.6133 13.3549 23.7668 13.0341C23.9203 12.7132 24 12.3616 24 12.0059C24 11.6501 23.9203 11.299 23.7668 10.9782C23.6133 10.6573 23.3899 10.3747 23.113 10.1516L21.2323 8.64007C21.117 8.54797 21.0268 8.42784 20.9702 8.29147C20.9136 8.15511 20.8924 8.00666 20.9086 7.85989L21.1694 5.46028C21.2061 5.12761 21.1722 4.79081 21.07 4.47212C20.9679 4.15342 20.7997 3.86017 20.5765 3.6109C20.3533 3.36162 20.0801 3.16201 19.7747 3.02552C19.4693 2.88903 19.1386 2.81846 18.8041 2.81851C18.7173 2.8185 18.6306 2.82334 18.5443 2.83267L16.1461 3.09387C16.1129 3.09742 16.0795 3.09897 16.0461 3.09875C15.9146 3.09882 15.7847 3.06898 15.6662 3.01185C15.5477 2.95472 15.4436 2.87169 15.3616 2.76871L13.8497 0.887109C13.6272 0.609908 13.3453 0.385916 13.0248 0.232404ZM15.0184 4.36617C15.3394 4.52044 15.6911 4.6003 16.0471 4.59954C16.1322 4.59977 16.2173 4.59524 16.302 4.58636L18.7002 4.32565C18.7334 4.32216 18.7668 4.32012 18.8001 4.32028C18.924 4.32022 19.0466 4.34636 19.1597 4.39693C19.2728 4.44751 19.374 4.52179 19.4566 4.61419C19.5393 4.70659 19.6015 4.81538 19.6392 4.93349C19.6769 5.05159 19.6892 5.17595 19.6755 5.29917L19.4147 7.69926C19.3706 8.09658 19.4277 8.49832 19.5807 8.86758C19.7338 9.23683 19.9778 9.56139 20.29 9.81082L22.1687 11.3219C22.2709 11.4043 22.3533 11.5085 22.4099 11.627C22.4666 11.7455 22.496 11.875 22.496 12.0064C22.496 12.1377 22.4666 12.2677 22.4099 12.3862C22.3533 12.5047 22.2709 12.6089 22.1687 12.6913L20.281 14.1985C19.969 14.4482 19.7251 14.7728 19.572 15.1422C19.419 15.5116 19.3618 15.9136 19.4057 16.311L19.6665 18.7106C19.6803 18.8336 19.6679 18.9579 19.6303 19.0758C19.5927 19.1937 19.5307 19.3024 19.4482 19.3946C19.3658 19.4868 19.2648 19.5609 19.152 19.6114C19.0391 19.6619 18.9168 19.6876 18.7931 19.6875C18.7597 19.6878 18.7264 19.6863 18.6932 19.6827L16.2949 19.4215C15.8979 19.3778 15.4963 19.4353 15.1273 19.5884C14.7584 19.7416 14.4341 19.9853 14.1845 20.2973L12.6806 22.1701C12.5983 22.2728 12.494 22.3559 12.3754 22.4128C12.2569 22.4697 12.1271 22.4992 11.9956 22.4992C11.8641 22.4992 11.7343 22.4697 11.6157 22.4128C11.4972 22.3559 11.3929 22.2728 11.3106 22.1701L9.8007 20.2905C9.55099 19.9786 9.22667 19.7347 8.85775 19.5816C8.48884 19.4285 8.08726 19.3711 7.69024 19.4146L5.292 19.6758C5.25882 19.6795 5.22544 19.681 5.19207 19.6807C5.06842 19.6807 4.94618 19.6543 4.83338 19.6036C4.72059 19.5529 4.6198 19.4788 4.53767 19.3863C4.45553 19.2938 4.39391 19.185 4.35686 19.067C4.31981 18.949 4.30817 18.8247 4.32271 18.7018L4.5835 16.3022C4.62723 15.9048 4.56994 15.5028 4.41691 15.1334C4.26388 14.7641 4.02009 14.4391 3.70817 14.1892L1.82953 12.6786C1.72699 12.5963 1.64424 12.4916 1.58737 12.373C1.53051 12.2544 1.50098 12.1247 1.50098 11.9932C1.50098 11.8616 1.53051 11.7315 1.58737 11.6128C1.64424 11.4942 1.72699 11.3901 1.82953 11.3077L3.70716 9.79568C4.01944 9.54632 4.2635 9.2222 4.41657 8.85293C4.56964 8.48366 4.62674 8.08145 4.58253 7.68413L4.3217 5.28452C4.30791 5.16156 4.32023 5.03671 4.35784 4.91884C4.39544 4.80098 4.45751 4.69273 4.53995 4.60052C4.6224 4.50831 4.72335 4.43423 4.83625 4.38375C4.94914 4.33327 5.0714 4.30752 5.19505 4.30759C5.22843 4.30732 5.2618 4.30887 5.29499 4.31247L7.69323 4.57367C8.08991 4.61721 8.49117 4.55993 8.85989 4.40719C9.2286 4.25444 9.55288 4.01113 9.80271 3.69975L11.3136 1.82889C11.3961 1.72661 11.5004 1.6439 11.619 1.58722C11.7375 1.53054 11.8672 1.50129 11.9986 1.50129C12.13 1.50129 12.2597 1.53054 12.3782 1.58722C12.4967 1.6439 12.6011 1.72661 12.6836 1.82889L14.1935 3.70854C14.4155 3.98712 14.6975 4.21191 15.0184 4.36617Z"
				fill="#406D0D"
			/>
		</svg>
	),
	SPINNER: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			version="1.1"
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 38 38"
			// style="enable-background:new 0 0 38 38;"
			xmlSpace="preserve"
		>
			<g>
				<g transform="rotate(0 50 50)">
					<path
						fill="currentColor"
						d="M19,0.3L19,0.3c0.8,0,1.5,1,1.5,2.2v5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2V2.4
C17.5,1.2,18.2,0.3,19,0.3z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.9230769230769231s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(27.692307692307693 50 50)">
					<path
						fill="currentColor"
						d="M8.3,18.2L8.3,18.2c0.8,0,1.5,1,1.5,2.2l0,5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2l0-5.7
C6.8,19.2,7.4,18.2,8.3,18.2z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.8461538461538461s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(55.38461538461539 50 50)">
					<path
						fill="currentColor"
						d="M7.1,39.1L7.1,39.1c0.8,0,1.5,1,1.5,2.2l0,5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2l0-5.7
C5.6,40,6.3,39.1,7.1,39.1z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.7692307692307693s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(83.07692307692308 50 50)">
					<path
						fill="currentColor"
						d="M15.7,58.1L15.7,58.1c0.8,0,1.5,1,1.5,2.2l0,5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2l0-5.7
C14.2,59,14.9,58.1,15.7,58.1z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.6923076923076923s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(110.76923076923077 50 50)">
					<path
						fill="currentColor"
						d="M32.3,70.9L32.3,70.9c0.8,0,1.5,1,1.5,2.2v5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2v-5.7
C30.8,71.9,31.4,70.9,32.3,70.9z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.6153846153846154s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(138.46153846153845 50 50)">
					<path
						fill="currentColor"
						d="M52.8,74.6L52.8,74.6c0.8,0,1.5,1,1.5,2.2v5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2v-5.7
C51.3,75.5,52,74.6,52.8,74.6z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.5384615384615384s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(166.15384615384616 50 50)">
					<path
						fill="currentColor"
						d="M72.7,68.3L72.7,68.3c0.8,0,1.5,1,1.5,2.2v5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2v-5.7
C71.2,69.2,71.9,68.3,72.7,68.3z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.46153846153846156s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(193.84615384615384 50 50)">
					<path
						fill="currentColor"
						d="M87.5,53.4L87.5,53.4c0.8,0,1.5,1,1.5,2.2v5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2v-5.7
C86,54.4,86.6,53.4,87.5,53.4z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.38461538461538464s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(221.53846153846155 50 50)">
					<path
						fill="currentColor"
						d="M93.6,33.5L93.6,33.5c0.8,0,1.5,1,1.5,2.2v5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2v-5.7
C92.1,34.4,92.8,33.5,93.6,33.5z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.3076923076923077s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(249.23076923076923 50 50)">
					<path
						fill="currentColor"
						d="M89.7,12.9L89.7,12.9c0.8,0,1.5,1,1.5,2.2v5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2v-5.7
C88.2,13.9,88.9,12.9,89.7,12.9z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.23076923076923078s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(276.9230769230769 50 50)">
					<path
						fill="currentColor"
						d="M76.8-3.5L76.8-3.5c0.8,0,1.5,1,1.5,2.2v5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2v-5.7
C75.3-2.5,76-3.5,76.8-3.5z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.15384615384615385s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(304.61538461538464 50 50)">
					<path
						fill="currentColor"
						d="M57.7-12L57.7-12c0.8,0,1.5,1,1.5,2.2v5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2v-5.7
C56.2-11,56.9-12,57.7-12z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="-0.07692307692307693s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
				<g transform="rotate(332.3076923076923 50 50)">
					<path
						fill="currentColor"
						d="M36.8-10.6L36.8-10.6c0.8,0,1.5,1,1.5,2.2l0,5.7c0,1.2-0.7,2.2-1.5,2.2l0,0c-0.8,0-1.5-1-1.5-2.2l0-5.7
C35.3-9.7,36-10.6,36.8-10.6z		"
					>
						<animate
							accumulate="none"
							additive="replace"
							attributeName="opacity"
							begin="0s"
							calcMode="linear"
							dur="1s"
							fill="remove"
							repeatCount="indefinite"
							restart="always"
							// times="0;1"
							values="1;0"
						/>
					</path>
				</g>
			</g>
		</svg>
	),
	LOGO: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 88 33"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="svea-logo-light-bg" clipPath="url(#clip0_1635_7351)">
				<path
					id="Path_1073"
					d="M13.9336 9.03504H7.97141C5.81432 9.03504 5.56437 7.96486 5.56437 7.15839C5.56437 5.48626 6.44305 4.80395 8.59771 4.80395H20.1471V0.181641H7.94173C2.52372 0.181641 0 2.37875 0 7.09729C0 11.5324 2.40021 13.5981 7.55418 13.5981H12.8618C14.9528 13.5981 15.6224 14.0909 15.6224 15.6268C15.6224 16.9025 15.1361 17.5939 12.5618 17.5939H0.864579V22.2133H13.2776C18.6752 22.2133 21.1901 20.0619 21.1901 15.4445C21.1901 10.8934 19.088 9.03504 13.9336 9.03504Z"
					fill="currentColor"
				/>
				<path
					id="Path_1074"
					d="M39.3639 0.182617L33.0638 15.2751L26.9076 0.182617H20.8672L30.5731 22.221H35.7889L45.0912 0.185025L39.3639 0.182617Z"
					fill="currentColor"
				/>
				<path
					id="Path_1075"
					d="M54.4635 4.71783H62.2856V0.183105H54.374C47.2054 0.183105 43.8672 3.8055 43.8672 11.5834C43.8672 15.5999 44.9934 18.4389 47.309 20.2617C49.5867 22.0709 51.8026 22.2182 54.2553 22.2182H62.2861V17.6844H54.4635C51.2283 17.6844 49.9305 16.4968 49.8016 13.3364H62.2851V8.80216H49.8561C50.1342 6.01897 51.6066 4.71783 54.4635 4.71783Z"
					fill="currentColor"
				/>
				<path
					id="Path_1076"
					d="M72.7051 0.183105L63.2773 22.2187H68.9871L70.8977 17.1696H79.6111L81.5786 22.2187H87.53L78.0366 0.183105H72.7051ZM72.6808 12.5497L75.1997 5.99876L77.8158 12.5497H72.6808Z"
					fill="currentColor"
				/>
				<path
					id="Bar"
					d="M86.4553 26.4387H1.79439C1.20249 26.4387 0.722656 26.9135 0.722656 27.4993V31.1212C0.722656 31.7069 1.20249 32.1817 1.79439 32.1817H86.4553C87.0472 32.1817 87.527 31.7069 87.527 31.1212V27.4993C87.527 26.9135 87.0472 26.4387 86.4553 26.4387Z"
					fill="#00AECE"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1635_7351">
					<rect width="87.5294" height="32" fill="white" transform="translate(0 0.181641)" />
				</clipPath>
			</defs>
		</svg>
	),
	TOOLTIP: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="12" cy="12" r="12" fill="#F1F0EB" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9967 19.5C16.1387 19.5 19.4967 16.142 19.4967 12C19.4967 7.85799 16.1387 4.5 11.9967 4.5C7.85466 4.5 4.49667 7.85799 4.49667 12C4.49667 16.142 7.85466 19.5 11.9967 19.5Z"
				fill="#434343"
				stroke="#434343"
				strokeWidth="0.982423"
			/>
			<path
				d="M9.99667 9.99982C9.99667 8.98246 10.76 8.12777 11.7707 8.01245C12.7814 7.89778 13.7175 8.55975 13.9455 9.55116C14.1741 10.5418 13.6221 11.5465 12.6634 11.8859C12.2634 12.0272 11.9961 12.4053 11.9967 12.8293V13.4999"
				stroke="white"
				strokeWidth="0.982423"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 15.5C11.862 15.5 11.75 15.612 11.75 15.75C11.75 15.888 11.862 16 12 16C12.138 16 12.25 15.888 12.25 15.75C12.25 15.612 12.138 15.5 12 15.5V15.5"
				stroke="white"
				strokeWidth="0.982423"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	TRASHCAN: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.02288 12.1104C6.1229 12.2104 6.25856 12.2667 6.40001 12.2667C6.54146 12.2667 6.67712 12.2104 6.77714 12.1104C6.87716 12.0104 6.93334 11.8748 6.93334 11.7333V6.39999C6.93334 6.25854 6.87716 6.12292 6.77714 6.0229C6.67712 5.92289 6.54146 5.86665 6.40001 5.86665C6.25856 5.86665 6.1229 5.92289 6.02288 6.0229C5.92286 6.12292 5.86668 6.25854 5.86668 6.39999V11.7333C5.86668 11.8748 5.92286 12.0104 6.02288 12.1104Z"
				fill="currentColor"
			/>
			<path
				d="M9.60001 12.2667C9.45856 12.2667 9.3229 12.2104 9.22288 12.1104C9.12286 12.0104 9.06667 11.8748 9.06667 11.7333V6.39999C9.06667 6.25854 9.12286 6.12292 9.22288 6.0229C9.3229 5.92289 9.45856 5.86665 9.60001 5.86665C9.74146 5.86665 9.87711 5.92289 9.97713 6.0229C10.0772 6.12292 10.1333 6.25854 10.1333 6.39999V11.7333C10.1333 11.8748 10.0772 12.0104 9.97713 12.1104C9.87711 12.2104 9.74146 12.2667 9.60001 12.2667Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.4 0H9.60001C10.0242 0.000376592 10.431 0.169121 10.731 0.469097C11.0309 0.769074 11.1996 1.17577 11.2 1.6V2.13335H15.4667C15.6081 2.13335 15.7438 2.18958 15.8438 2.2896C15.9438 2.38961 16 2.52523 16 2.66668C16 2.80813 15.9438 2.94374 15.8438 3.04376C15.7438 3.14378 15.6081 3.20001 15.4667 3.20001H14.3572L13.413 14.533C13.3774 14.9321 13.1943 15.3036 12.8995 15.5749C12.6047 15.8461 12.2193 15.9977 11.8187 16H4.18203C3.78118 15.998 3.39553 15.8463 3.10063 15.5749C2.80572 15.3034 2.62282 14.9316 2.58773 14.5323L1.64286 3.20001H0.533333C0.391885 3.20001 0.256226 3.14378 0.156207 3.04376C0.0561872 2.94374 0 2.80813 0 2.66668C0 2.52523 0.0561872 2.38961 0.156207 2.2896C0.256226 2.18958 0.391885 2.13335 0.533333 2.13335H4.8V1.6C4.80038 1.17577 4.96906 0.769074 5.26904 0.469097C5.56901 0.169121 5.97577 0.000376592 6.4 0ZM10.1333 2.13333V1.6C10.1332 1.45861 10.0769 1.32307 9.97691 1.22309C9.87694 1.12311 9.7414 1.06685 9.60001 1.06667H6.4C6.25861 1.06685 6.12307 1.12311 6.0231 1.22309C5.92312 1.32307 5.86686 1.45861 5.86667 1.6V2.13333H10.1333ZM3.65369 14.4441L2.71645 3.20003H13.2907L12.3541 14.4441C12.3423 14.5773 12.2812 14.7012 12.1828 14.7917C12.0844 14.8822 11.9559 14.9326 11.8222 14.9334H4.18559C4.05146 14.9343 3.92198 14.8844 3.82326 14.7936C3.72454 14.7028 3.66394 14.5779 3.65369 14.4441Z"
				fill="currentColor"
			/>
		</svg>
	),
	WARNING_SIGN: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill={color}
			viewBox="0 0 22 22"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.6793 18.6855L12.7016 1.52997C12.5389 1.21928 12.2943 0.959021 11.9944 0.777466C11.6945 0.59591 11.3506 0.5 11.0001 0.5C10.6495 0.5 10.3057 0.59591 10.0058 0.777466C9.70584 0.959021 9.46129 1.21928 9.29859 1.52997L0.31994 18.6855C0.166114 18.9786 0.0905114 19.3064 0.100482 19.6373C0.110453 19.9681 0.205641 20.2909 0.376834 20.5742C0.548027 20.8574 0.789439 21.0915 1.07765 21.254C1.36586 21.4164 1.69112 21.5017 2.02193 21.5015H19.9773C20.3081 21.5017 20.6334 21.4164 20.9216 21.254C21.2098 21.0915 21.4512 20.8574 21.6224 20.5742C21.7936 20.2909 21.8888 19.9681 21.8987 19.6373C21.9087 19.3064 21.8331 18.9786 21.6793 18.6855ZM10.0391 7.55595C10.0391 7.30106 10.1403 7.05667 10.3205 6.87643C10.5006 6.69619 10.7449 6.59486 10.9996 6.59486C11.2543 6.59486 11.4986 6.69619 11.6788 6.87643C11.8589 7.05667 11.9601 7.30106 11.9601 7.55595V13.3225C11.9601 13.5774 11.8589 13.8221 11.6788 14.0023C11.4986 14.1825 11.2543 14.2836 10.9996 14.2836C10.7449 14.2836 10.5006 14.1825 10.3205 14.0023C10.1403 13.8221 10.0391 13.5774 10.0391 13.3225V7.55595ZM11.0207 18.6182H11.0476C11.2367 18.6171 11.4235 18.5774 11.5966 18.5014C11.7697 18.4253 11.9254 18.3146 12.0542 18.1761C12.1838 18.0392 12.2845 17.8776 12.3505 17.701C12.4165 17.5243 12.4464 17.3361 12.4384 17.1477C12.424 16.7686 12.2636 16.4098 11.9907 16.1465C11.7179 15.8831 11.3537 15.7356 10.9746 15.7349H10.9478C10.5685 15.7461 10.2084 15.9046 9.94403 16.177C9.81563 16.3147 9.7156 16.4766 9.64968 16.6531C9.58376 16.8295 9.55324 17.0172 9.55984 17.2054C9.57374 17.5842 9.73362 17.9428 10.006 18.2062C10.2783 18.4696 10.642 18.6172 11.0207 18.6182Z"
				fill="currentColor"
			/>
		</svg>
	),

	// // old bank icons:
	FOUR_STARS_IN_SQUARE: ({ color, height }) => (
		<svg height={height} color={color} viewBox="0 0 16 15">
			<g fill="currentColor" fillRule="nonzero">
				<path d="M6.3 2.328H4.712l.794-1.32A.656.656 0 0 0 5.25.09a.718.718 0 0 0-.956.246L3.5 1.657 2.706.337A.715.715 0 0 0 1.75.09a.658.658 0 0 0-.256.918l.794 1.32H.7c-.386 0-.7.301-.7.672 0 .371.314.672.7.672h1.588l-.794 1.32a.656.656 0 0 0 .256.918c.11.06.231.09.35.09.24 0 .477-.12.606-.336L3.5 4.343l.794 1.321A.703.703 0 0 0 4.9 6c.119 0 .24-.028.35-.09a.658.658 0 0 0 .256-.918l-.794-1.32H6.3c.386 0 .7-.3.7-.672 0-.37-.314-.672-.7-.672zM15.3 2.328h-1.588l.794-1.32A.656.656 0 0 0 14.25.09a.718.718 0 0 0-.956.246L12.5 1.657l-.794-1.32A.715.715 0 0 0 10.75.09a.658.658 0 0 0-.256.918l.794 1.32H9.7c-.386 0-.7.301-.7.672 0 .371.314.672.7.672h1.588l-.794 1.32a.656.656 0 0 0 .256.918c.11.06.231.09.35.09.24 0 .477-.12.606-.336l.794-1.321.794 1.321A.703.703 0 0 0 13.9 6c.119 0 .24-.028.35-.09a.658.658 0 0 0 .256-.918l-.794-1.32H15.3c.386 0 .7-.3.7-.672 0-.37-.314-.672-.7-.672zM6.3 11.328H4.712l.794-1.32a.656.656 0 0 0-.256-.918.717.717 0 0 0-.956.246L3.5 10.657l-.794-1.32a.715.715 0 0 0-.956-.247.658.658 0 0 0-.256.918l.794 1.32H.7c-.386 0-.7.301-.7.672 0 .371.314.672.7.672h1.588l-.794 1.32a.656.656 0 0 0 .256.918c.11.06.231.09.35.09.24 0 .477-.12.606-.336l.794-1.321.794 1.321A.703.703 0 0 0 4.9 15c.119 0 .24-.028.35-.09a.658.658 0 0 0 .256-.918l-.794-1.32H6.3c.386 0 .7-.3.7-.672 0-.37-.314-.672-.7-.672zM15.3 11.328h-1.588l.794-1.32a.656.656 0 0 0-.256-.918.718.718 0 0 0-.956.246l-.794 1.321-.794-1.32a.715.715 0 0 0-.956-.247.657.657 0 0 0-.256.918l.794 1.32H9.7c-.386 0-.7.301-.7.672 0 .371.314.672.7.672h1.588l-.794 1.32a.656.656 0 0 0 .256.918c.11.06.231.09.35.09.24 0 .477-.12.606-.336l.794-1.321.794 1.321A.703.703 0 0 0 13.9 15c.119 0 .24-.028.35-.09a.658.658 0 0 0 .256-.918l-.794-1.32H15.3c.386 0 .7-.3.7-.672 0-.37-.314-.672-.7-.672z" />
			</g>
		</svg>
	),
	ACTIVATE: ({ color, height }) => (
		<svg height={height} color={color} viewBox="0 0 32 32">
			<g fill="currentColor" fillRule="evenodd">
				<path
					fillRule="nonzero"
					d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm0 3.2C8.93 3.2 3.2 8.93 3.2 16S8.93 28.8 16 28.8 28.8 23.07 28.8 16 23.07 3.2 16 3.2z"
				/>
				<path d="M24 16l-12 6V10z" />
			</g>
		</svg>
	),
	// ADD_BOX:  ({ color, height }) => <></>,
	// ADD_CIRCLE:  ({ color, height }) => <></>,
	// ALARM_BELL:  ({ color, height }) => <></>,
	// ALARM_BELL_DARK:  ({ color, height }) => <></>,
	// ARROW:  ({ color, height }) => <></>,
	// ARROW_BACKWARD_SSO:  ({ color, height }) => <></>,
	ARROW_BACKWARD: ({ color, height }) => (
		<svg height={height} color={color} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
			<path d="M0 0h24v24H0z" fill="none" />
			<path fill="currentColor" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
		</svg>
	),
	ARROW_FORWARD: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			className="rotate-180"
		>
			<path d="M0 0h24v24H0z" fill="none" />
			<path fill="currentColor" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
		</svg>
	),
	// ARROW_LEFT_TO_RIGHT:  ({ color, height }) => <></>,
	// ARROW_RIGHT_TO_LEFT:  ({ color, height }) => <></>,
	// ARROW_FORWARD:  ({ color, height }) => <></>,
	ARROW_LEFT_TO_RIGHT: ({ height }) => (
		<svg height={height} viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
			<g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="Icon/Incoming_arrow_green">
					<g id="Incoming_arrow_green">
						<circle id="Oval-2" fill="#D7F0BB" cx="10" cy="10" r="10" />
						<polygon
							id="Shape"
							fill="#416D10"
							fillRule="nonzero"
							opacity="0.5"
							transform="translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "
							points="16 9.25 6.8725 9.25 11.065 5.0575 10 4 4 10 10 16 11.0575 14.9425 6.8725 10.75 16 10.75"
						/>
					</g>
				</g>
			</g>
		</svg>
	),
	ARROW_RIGHT_TO_LEFT: ({ height }) => (
		<svg height={height} viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
			<g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="Icon/Outgoing_arrow_red">
					<g id="Outgoing_arrow_red">
						<circle id="Oval-2" fill="#F0B9B9" cx="10" cy="10" r="10" />
						<polygon
							id="Shape"
							fill="#6F1010"
							fillRule="nonzero"
							opacity="0.5"
							points="16 9.25 6.8725 9.25 11.065 5.0575 10 4 4 10 10 16 11.0575 14.9425 6.8725 10.75 16 10.75"
						/>
					</g>
				</g>
			</g>
		</svg>
	),
	ARROW_UP: ({ color, height }) => (
		<svg height={height} color={color} viewBox="0 0 16 16">
			<g id="Symbols" stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
				<polygon
					id="path-1"
					fill=""
					transform="translate(7.573093, 8.384312) rotate(-135.000000) translate(-7.573093, -8.384312) "
					points="13.8181519 8.19925593 12.7392624 7.15603798 8.17564842 11.7119244 8.1649639 2.26123048 6.61946877 2.26123048 6.61946877 11.6655683 2.30753736 7.34590945 1.32803458 8.32541223 7.5100151 14.5073927"
				/>
			</g>
		</svg>
	),
	ARROW_RETURN: ({ height }) => (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" height={height}>
			<circle cx="16" cy="16" r="16" fill="#fbdeb2" />
			<path
				fill="#f29200"
				d="M299.075 462.811a8.494 8.494 0 0 0-8.767 7.115l-1.4-1.4a1 1 0 1 0-1.414 1.415l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.415l-1.067 1.068a6.467 6.467 0 0 1 11.034-2.667 6.469 6.469 0 0 1-5.1 10.811 1 1 0 0 0-.1 2c.139.007.277.01.414.01a8.47 8.47 0 0 0 .4-16.93z"
				transform="translate(-282.121 -455.271)"
			/>
		</svg>
	),
	// BANK_ID:  ({ color, height }) => <></>,
	// BANK_ID_VAR:  ({ color, height }) => <></>,
	BANKGIRO_LINK: ({ color, height }) => (
		<svg viewBox="0 0 19.96 19.81" color={color} height={height}>
			<path
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2px"
				d="M18.77 7.46v-5a1.27 1.27 0 00-1.26-1.25h-15A1.25 1.25 0 001.2 2.43v13.8a1.25 1.25 0 001.25 1.26h5"
				transform="translate(-.6 -.59)"
			/>
			<path
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2px"
				d="M4.28 5h11.4"
				transform="translate(-.6 -.59)"
			/>
			<path
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2px"
				d="M15 16.77a1.88 1.88 0 01-.53 1.61l-1.08 1.05a2 2 0 01-2.82-2.82l1.08-1.08a1.88 1.88 0 011.57-.53"
				transform="translate(-.6 -.59)"
			/>
			<path
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2px"
				d="M16.77 15a1.88 1.88 0 001.61-.52l1.06-1.08a2 2 0 00-2.85-2.82l-1.07 1.08a1.84 1.84 0 00-.52 1.55"
				transform="translate(-.6 -.59)"
			/>
			<path
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2px"
				d="M13.12 16.86l3.76-3.76"
				transform="translate(-.6 -.59)"
			/>
			<path
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2px"
				d="M4.28 8.3h11.4"
				transform="translate(-.6 -.59)"
			/>
		</svg>
	),
	// CHECKBOX_CHECKED_OLD:  ({ color, height }) => <></>,
	// CHECKMARK_IN_SUN:  ({ color, height }) => <></>,
	// CHECK_ICON:  ({ color, height }) => <></>,
	// CHECK_IN_CIRCLE:  ({ color, height }) => <></>,
	// CHECKED_DONE:  ({ color, height }) => <></>,
	// CHEVRON_RIGHT:  ({ color, height }) => <></>,
	COG_WHEEL: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			viewBox="0 0 16 16"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g
					id="Desktop_Creditcard_01"
					transform="translate(-311.000000, -349.000000)"
					fill="currentColor"
					fillRule="nonzero"
				>
					<g id="Group-21" transform="translate(230.000000, 161.000000)">
						<g id="Group-18" transform="translate(81.000000, 188.000000)">
							<path
								d="M13.7109332,8.8 C13.7109332,8.5593752 13.7921828,8.2406248 13.7921828,8 C13.7921828,7.7593752 13.7921828,7.4406248 13.7109332,7.2 L15.3921828,6 C15.551558,5.9187504 15.6328076,5.6812504 15.4734332,5.4406248 L13.8734332,2.6406248 C13.7921828,2.4 13.551558,2.3187504 13.3921828,2.4 L11.4734332,3.2812504 C11.0734332,2.9593752 10.5109332,2.6406248 10.0328076,2.4812504 L9.79218283,0.4 C9.79218283,0.1593752 9.63280763,0 9.39218283,0 L6.19218283,0 C5.95155803,0 5.79218283,0.1593752 5.79218283,0.4 L5.55155803,2.4 C4.99218283,2.6406248 4.51093323,2.8812504 4.11093323,3.2 L2.19218283,2.4 C2.03280763,2.3187504 1.79218283,2.4 1.71093323,2.5593752 L0.110933234,5.3593752 C-0.0484419663,5.6 -0.0484419663,5.8406248 0.192182834,5.9187504 L1.87343323,7.2 C1.87343323,7.4406248 1.79218283,7.7593752 1.79218283,8 C1.79218283,8.2406248 1.79218283,8.5593752 1.87343323,8.8 L0.192182834,10 C0.0328076337,10.0812504 -0.0484419663,10.3187504 0.110933234,10.5593752 L1.71093323,13.3593752 C1.79218283,13.6 2.03280763,13.6812504 2.19218283,13.6 L4.11093323,12.7187504 C4.51093323,13.0406248 5.07343323,13.3593752 5.55155803,13.5187504 L5.79218283,15.6 C5.79218283,15.8406248 5.95155803,16 6.19218283,16 L9.39218283,16 C9.63280763,16 9.79218283,15.8406248 9.79218283,15.6 L10.0328076,13.5187504 C10.5921828,13.2812504 11.0734332,13.0406248 11.4734332,12.7187504 L13.3921828,13.6 C13.551558,13.6812504 13.7921828,13.6 13.8734332,13.4406248 L15.4734332,10.6406248 C15.551558,10.4812504 15.551558,10.2406248 15.3921828,10.0812504 L13.7109332,8.8 Z M7.79218283,11.2 C6.03280763,11.2 4.59218283,9.7593752 4.59218283,8 C4.59218283,6.2406248 6.03280763,4.8 7.79218283,4.8 C9.55155803,4.8 10.9921828,6.2406248 10.9921828,8 C10.9921828,9.7593752 9.55155803,11.2 7.79218283,11.2 Z"
								id="Shape"
							/>
						</g>
					</g>
				</g>
			</g>
		</svg>
	),
	// COINS:  ({ color, height }) => <></>,
	// COMPLETED_CHECK:  ({ color, height }) => <></>,
	// CROSS_ICON:  ({ color, height }) => <></>,
	// DATE_RANGE:  ({ color, height }) => <></>,
	// DOG_WITH_QUESTIONMARK:  ({ color, height }) => <></>,
	// EDIT_OLD:  ({ color, height }) => <></>,
	EMAIL: ({ color, height }) => (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 11.89" color={color} height={height}>
			<path
				fill="currentColor"
				d="M318.46,418.82a0,0,0,0,1,0,0l0,0a1.6,1.6,0,0,0-1.19-.57H304.37a1.58,1.58,0,0,0-1.2.58h0s0,0,0,0a1.59,1.59,0,0,0-.34,1v8.71a1.58,1.58,0,0,0,1.57,1.59h12.86a1.59,1.59,0,0,0,1.57-1.59v-8.7A1.59,1.59,0,0,0,318.46,418.82Zm-1.35.38-5.18,4.06a1.83,1.83,0,0,1-2.26,0l-5.18-4.06Zm.12,9.89H304.37a.57.57,0,0,1-.57-.59v-8.56l5.25,4.1a2.82,2.82,0,0,0,3.5,0l5.25-4.1v8.57A.58.58,0,0,1,317.23,429.09Z"
				transform="translate(-302.8 -418.2)"
			/>
		</svg>
	),
	// EMPTY_STATE_DOCUMENT:  ({ color, height }) => <></>,
	EYE: ({ color, height }) => (
		<svg height={height} color={color} viewBox="0 0 16 12">
			<path
				fill="currentColor"
				fillRule="nonzero"
				d="M8 0C2.182 0 0 5.818 0 5.818s2.182 5.818 8 5.818 8-5.818 8-5.818S13.818 0 8 0zm0 2.182a3.637 3.637 0 1 1 0 7.273 3.637 3.637 0 0 1 0-7.273zm0 1.454A2.182 2.182 0 1 0 8 8a2.182 2.182 0 0 0 0-4.364z"
			/>
		</svg>
	),
	EXCEL_ICON: ({ color, height }) => (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20" color={color} height={height}>
			<path
				fill="currentColor"
				fillRule="nonzero"
				d="M4 0C2.906 0 2 .906 2 2v5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2v2c0 1.094.906 2 2 2h12c1.094 0 2-.906 2-2V5l-5-5H4zm0 2h8v4h4v1H4V2zM2.025 9h1.248l.725 1.717L4.725 9H5.97l-1.268 2.479L6 14H4.738l-.74-1.748L3.262 14H2l1.295-2.521L2.025 9zM7 9h1v4h2v1H7V9zm5.49 0c1.423.041 1.51 1.283 1.51 1.504h-.969c0-.103.018-.697-.558-.697-.175 0-.567.077-.537.56.029.443.611.652.718.7.224.081 1.333.575 1.342 1.583.002.214-.053 1.335-1.486 1.35-1.56.017-1.664-1.325-1.664-1.602h.974c0 .147.013.858.69.803.407-.034.496-.327.51-.545.023-.367-.328-.587-.698-.765-.52-.25-1.342-.558-1.357-1.532-.013-.877.631-1.384 1.525-1.359zM4 16h12v2H4v-2z"
			/>
		</svg>
	),
	// EXTERNAL_LINK_OLD:  ({ color, height }) => <></>,
	// FALLBACK_FILE_ICON:  ({ color, height }) => <></>,
	FILE_ICON: ({ color, height }) => (
		<svg
			color={color}
			height={height}
			viewBox="0 0 22 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.17733 9.46667H16.9107C17.1052 9.46667 17.2917 9.38941 17.4292 9.25188C17.5667 9.11436 17.644 8.92783 17.644 8.73333C17.644 8.53884 17.5667 8.35231 17.4292 8.21479C17.2917 8.07726 17.1052 8 16.9107 8H5.17733C4.98284 8 4.79631 8.07726 4.65878 8.21479C4.52126 8.35231 4.444 8.53884 4.444 8.73333C4.444 8.92783 4.52126 9.11436 4.65878 9.25188C4.79631 9.38941 4.98284 9.46667 5.17733 9.46667Z"
				fill="currentColor"
			/>
			<path
				d="M16.9107 13.8667H5.17733C4.98284 13.8667 4.79631 13.7894 4.65878 13.6519C4.52126 13.5144 4.444 13.3278 4.444 13.1333C4.444 12.9388 4.52126 12.7523 4.65878 12.6148C4.79631 12.4773 4.98284 12.4 5.17733 12.4H16.9107C17.1052 12.4 17.2917 12.4773 17.4292 12.6148C17.5667 12.7523 17.644 12.9388 17.644 13.1333C17.644 13.3278 17.5667 13.5144 17.4292 13.6519C17.2917 13.7894 17.1052 13.8667 16.9107 13.8667Z"
				fill="currentColor"
			/>
			<path
				d="M5.17733 18.2667H11.044C11.2385 18.2667 11.425 18.1894 11.5625 18.0519C11.7 17.9143 11.7773 17.7278 11.7773 17.5333C11.7773 17.3388 11.7 17.1523 11.5625 17.0148C11.425 16.8772 11.2385 16.8 11.044 16.8H5.17733C4.98284 16.8 4.79631 16.8772 4.65878 17.0148C4.52126 17.1523 4.444 17.3388 4.444 17.5333C4.444 17.7278 4.52126 17.9143 4.65878 18.0519C4.79631 18.1894 4.98284 18.2667 5.17733 18.2667Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.2 24.1333H19.8C20.3832 24.1326 20.9424 23.9005 21.3548 23.4881C21.7672 23.0757 21.9992 22.5166 22 21.9333V5.68559C21.9995 5.39209 21.9406 5.10163 21.8266 4.83117C21.7126 4.56071 21.5459 4.31568 21.3361 4.1104L18.4477 1.29147C18.0372 0.889597 17.4852 0.665189 16.9107 0.666664H2.2C1.61676 0.66744 1.05763 0.899469 0.645218 1.31188C0.232806 1.72429 0.0007761 2.28343 0 2.86666V21.9333C0.0007761 22.5166 0.232806 23.0757 0.645218 23.4881C1.05763 23.9005 1.61676 24.1326 2.2 24.1333ZM1.68175 2.34841C1.81922 2.21094 2.00559 2.13359 2.2 2.13333H16.9107C17.102 2.13394 17.2856 2.20859 17.423 2.34161L20.3123 5.16149C20.3821 5.2298 20.4376 5.31133 20.4756 5.40131C20.5135 5.4913 20.5331 5.58794 20.5333 5.68559V21.9333C20.5331 22.1277 20.4557 22.3141 20.3183 22.4516C20.1808 22.5891 19.9944 22.6664 19.8 22.6667H2.2C2.00559 22.6664 1.81922 22.5891 1.68175 22.4516C1.54428 22.3141 1.46693 22.1277 1.46667 21.9333V2.86666C1.46693 2.67225 1.54428 2.48588 1.68175 2.34841Z"
				fill="currentColor"
			/>
		</svg>
	),
	FILTER: ({ color, height }) => (
		<svg color={color} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path fill="currentColor" d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
	),
	// GEAR:  ({ color, height }) => <></>,
	HELP: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path d="M5.25 24a.75.75 0 01-.75-.75V19.5H2.25c-1.24 0-2.25-1-2.25-2.25v-15C0 1.01 1 0 2.25 0h19.5C22.99 0 24 1 24 2.25v15c0 1.24-1 2.25-2.25 2.25H11.5l-5.8 4.35a.75.75 0 01-.45.15zm-3-22.5a.75.75 0 00-.75.75v15c0 .41.34.75.75.75h3c.41 0 .75.34.75.75v3l4.8-3.6c.13-.1.29-.15.45-.15h10.5c.41 0 .75-.34.75-.75v-15a.75.75 0 00-.75-.75H2.25z" />
			<path
				fill="currentColor"
				d="M12 12a.75.75 0 01-.75-.75v-.26c0-.95.6-1.8 1.5-2.12a2.25 2.25 0 10-3-2.12.75.75 0 01-1.5 0 3.75 3.75 0 115 3.54c-.3.1-.5.39-.5.7v.26c0 .41-.34.75-.75.75z"
			/>
			<circle cx="12" cy="14.63" r="1.13" />
		</svg>
	),
	// I_ICON:  ({ color, height }) => <></>,
	// I_ICON_INVERTED:  ({ color, height }) => <></>,
	I_ICON_SERIF: ({ color, height }) => (
		<svg height={height} color={color} viewBox="0 0 13 32" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6.4 0a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6zM0 12.8V16h3.2v12.8H0V32h12.8v-3.2H9.6V14.4c0-.88-.72-1.6-1.6-1.6H0z"
				fill="currentColor"
				fillRule="nonzero"
			/>
		</svg>
	),
	LOCK: ({ color, height }) => (
		<svg height={height} color={color} viewBox="0 0 16 21">
			<g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
				<g
					id="Desktop_02_02_01_Locked_Transactions_MVP"
					transform="translate(-230.000000, -177.000000)"
					fill="currentColor"
					fillRule="nonzero"
				>
					<path
						d="M238,177 C234.67619,177 232,179.67619 232,183 L232,184 C230.9,184 230,184.9 230,186 L230,196 C230,197.1 230.9,198 232,198 L244,198 C245.1,198 246,197.1 246,196 L246,186 C246,184.9 245.1,184 244,184 L244,183 C244,179.67619 241.32381,177 238,177 Z M238,179 C240.27619,179 242,180.723809 242,183 L242,184 L234,184 L234,183 C234,180.723809 235.723809,179 238,179 Z M238,189 C239.1,189 240,189.9 240,191 C240,192.1 239.1,193 238,193 C236.9,193 236,192.1 236,191 C236,189.9 236.9,189 238,189 Z"
						id="lock"
					/>
				</g>
			</g>
		</svg>
	),
	// MAGNIFYING_GLAS:  ({ color, height }) => <></>,
	// MOBILE_PHONE:  ({ color, height }) => <></>,
	// MOBILE_PHONE_GREY:  ({ color, height }) => <></>,
	PAPER_CLIP: ({ color, height }) => (
		<svg
			color={color}
			height={height}
			viewBox="0 0 16 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.75 24C4.3581 23.9984 3.02367 23.4447 2.03944 22.4604C1.05522 21.4762 0.501588 20.1419 0.5 18.75V7.5C0.5 5.51088 1.29018 3.6033 2.6967 2.19678C4.10322 0.790254 6.01088 0 8 0C9.98912 0 11.8968 0.790254 13.3033 2.19678C14.7098 3.6033 15.5 5.51088 15.5 7.5V15.749C15.5 15.9479 15.421 16.1386 15.2803 16.2793C15.1397 16.4199 14.9489 16.499 14.75 16.499C14.5511 16.499 14.3603 16.4199 14.2197 16.2793C14.079 16.1386 14 15.9479 14 15.749V7.5C14 5.9087 13.3678 4.38254 12.2426 3.25732C11.1174 2.13211 9.5913 1.5 8 1.5C6.4087 1.5 4.88257 2.13211 3.75735 3.25732C2.63214 4.38254 2 5.9087 2 7.5V18.75C2 19.7446 2.39508 20.6983 3.09834 21.4016C3.8016 22.1049 4.75544 22.5 5.75 22.5C6.74456 22.5 7.69838 22.1049 8.40164 21.4016C9.1049 20.6983 9.5 19.7446 9.5 18.75V7.5C9.5 7.10218 9.34196 6.72076 9.06065 6.43945C8.77935 6.15815 8.39782 6 8 6C7.60218 6 7.22064 6.15815 6.93933 6.43945C6.65803 6.72076 6.5 7.10218 6.5 7.5V17.25C6.5 17.4489 6.42097 17.6396 6.28032 17.7803C6.13967 17.9209 5.94891 18 5.75 18C5.55109 18 5.36032 17.9209 5.21967 17.7803C5.07901 17.6396 5 17.4489 5 17.25V7.5C5 6.70435 5.31607 5.94127 5.87868 5.37866C6.44129 4.81605 7.20435 4.5 8 4.5C8.79565 4.5 9.55871 4.81605 10.1213 5.37866C10.6839 5.94127 11 6.70435 11 7.5V18.75C10.9984 20.1419 10.4448 21.4762 9.46056 22.4604C8.47633 23.4447 7.1419 23.9984 5.75 24Z"
				fill="currentColor"
			/>
		</svg>
	),
	// PAPER_SCROLL:  ({ color, height }) => <></>,
	PAUSE: ({ color, height }) => (
		<svg height={height} color={color} viewBox="0 0 32 32">
			<path
				d="M16 32a16 16 0 1 1 0-32 16 16 0 0 1 0 32zm0-3.2a12.8 12.8 0 1 0 0-25.6 12.8 12.8 0 0 0 0 25.6zM11.2 8h3.2v16h-3.2V8zm6.4 0h3.2v16h-3.2V8z"
				fill="currentColor"
				fillRule="nonzero"
			/>
		</svg>
	),
	PDF_ICON: ({ color, height }) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			color={color}
			height={height}
			viewBox="0 0 18 20"
		>
			<path
				fill="currentColor"
				fillRule="nonzero"
				d="M4 0C2.906 0 2 .906 2 2v5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2v2c0 1.094.906 2 2 2h12c1.094 0 2-.906 2-2V5l-5-5H4zm0 2h8v4h4v1H4V2zM2 9h1.5a1.5 1.5 0 0 1 0 3H3v2H2V9zm9 0h3v1h-2v1h1.6v1H12v2h-1V9zm-5 .023h1.629C9.21 9.023 10 9.975 10 11.13v.771c0 1.168-.79 2.1-2.385 2.1H6V9.023zM3 10v1h.5a.5.5 0 0 0 0-1H3zm4 .023V13h.615C8.247 13 9 12.808 9 11.9v-.771c0-.914-.745-1.106-1.371-1.106H7zM4 16h12v2H4v-2z"
			/>
		</svg>
	),
	PHONE: ({ color, height }) => (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15.99" height={height} color={color}>
			<path
				fill="currentColor"
				d="M312.75,432.25a3.46,3.46,0,0,1-1.83-.52l-.06,0a27.43,27.43,0,0,1-7.42-7.42.16.16,0,0,1,0-.07,3.52,3.52,0,0,1,.51-4.31l.42-.42a1.5,1.5,0,0,1,1.06-.44h0a1.5,1.5,0,0,1,1.06.44l1.76,1.76h0a1.51,1.51,0,0,1,.43,1.07,1.47,1.47,0,0,1-.42,1l0,0a.46.46,0,0,0-.14.35.5.5,0,0,0,.14.35.5.5,0,0,1,0,.71.48.48,0,0,1-.7,0,1.46,1.46,0,0,1-.44-1.06,1.44,1.44,0,0,1,.41-1l0,0a.52.52,0,0,0,.14-.36.51.51,0,0,0-.13-.34h0l-1.78-1.77a.47.47,0,0,0-.35-.15h0a.47.47,0,0,0-.35.15l-.43.42a2.52,2.52,0,0,0-.34,3.11l0,0a26.71,26.71,0,0,0,7.07,7.07l0,0a2.53,2.53,0,0,0,3.12-.34l.42-.42a.5.5,0,0,0,0-.71l-1.77-1.77a.5.5,0,0,0-.71,0,1.5,1.5,0,0,1-1.06.44h0a1.5,1.5,0,0,1-1.06-.44.5.5,0,0,1,0-.71.5.5,0,0,1,.7,0,.5.5,0,0,0,.71,0,1.5,1.5,0,0,1,2.12,0l1.78,1.77a1.52,1.52,0,0,1,0,2.13l-.42.42A3.55,3.55,0,0,1,312.75,432.25Z"
				transform="translate(-302.89 -416.26)"
			/>
			<path
				fill="currentColor"
				d="M314.38,423a.75.75,0,0,1,0-1.5h0a.75.75,0,1,1,0,1.5Zm0-.5a.25.25,0,0,0,.25-.25c0-.28-.5-.28-.5,0a.26.26,0,0,0,.25.25Z"
				transform="translate(-302.89 -416.26)"
			/>
			<path
				fill="currentColor"
				d="M309.87,426.27a.55.55,0,0,1-.34-.13.5.5,0,0,1-.13-.53l.94-2.84a4.51,4.51,0,0,1,4-6.51h0a4.51,4.51,0,0,1,1.74.35,4.5,4.5,0,0,1,2.41,5.9,4.52,4.52,0,0,1-5.69,2.49l-2.77,1.23A.45.45,0,0,1,309.87,426.27Zm4.51-9a3.51,3.51,0,0,0-3.51,3.5,3.56,3.56,0,0,0,.45,1.72.51.51,0,0,1,0,.4l-.66,2,1.92-.85a.47.47,0,0,1,.4,0,3.52,3.52,0,0,0,4.59-1.88,3.5,3.5,0,0,0-3.23-4.86Z"
				transform="translate(-302.89 -416.26)"
			/>
			<path
				fill="currentColor"
				d="M314.38,421.26a.5.5,0,0,1,0-1,.5.5,0,0,0,0-1,.5.5,0,0,0-.5.5.5.5,0,0,1-1,0,1.5,1.5,0,1,1,1.5,1.5Z"
				transform="translate(-302.89 -416.26)"
			/>
		</svg>
	),
	// PHONE_CIRCLE:  ({ color, height }) => <></>,
	// PLUS_IN_CIRCLE:  ({ color, height }) => <></>,
	// PLUS_PERSON:  ({ color, height }) => <></>,
	// PRINT:  ({ color, height }) => <></>,
	// PRINTER:  ({ color, height }) => <></>,
	PRINTER_NO_BACKGROUND: ({ color, height }) => (
		<svg height={height} color={color} viewBox="0 0 16 16">
			<path
				fill="currentColor"
				id="a"
				d="M13.6 3.889H2.4C1.072 3.889 0 4.93 0 6.222v4.667h3.2V14h9.6v-3.111H16V6.222c0-1.29-1.072-2.333-2.4-2.333zm-2.4 8.555H4.8V8.556h6.4v3.888zM13.6 7c-.44 0-.8-.35-.8-.778 0-.428.36-.778.8-.778.44 0 .8.35.8.778 0 .428-.36.778-.8.778zm-.8-7H3.2v3.111h9.6V0z"
			/>
		</svg>
	),
	// QUESTION_MARK:  ({ color, height }) => <></>,
	// RADIOBUTTON_ACTIVE:  ({ color, height }) => <></>,
	// RADIOBUTTON_INACTIVE:  ({ color, height }) => <></>,
	// RELOAD:  ({ color, height }) => <></>,
	// REMOVE_BOX:  ({ color, height }) => <></>,
	// SHOPPING_BASKET:  ({ color, height }) => <></>,
	// SORTING_ARROW:  ({ color, height }) => <></>,
	// SPINNER_OLD:  ({ color, height }) => <></>,
	// WASTE_BIN:  ({ color, height }) => <></>,
	TRASH_CAN: ({ color, height }) => (
		<svg
			height={height}
			color={color}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.02288 12.1104C6.1229 12.2104 6.25856 12.2667 6.40001 12.2667C6.54146 12.2667 6.67712 12.2104 6.77714 12.1104C6.87716 12.0104 6.93334 11.8748 6.93334 11.7333V6.39999C6.93334 6.25854 6.87716 6.12292 6.77714 6.0229C6.67712 5.92289 6.54146 5.86665 6.40001 5.86665C6.25856 5.86665 6.1229 5.92289 6.02288 6.0229C5.92286 6.12292 5.86668 6.25854 5.86668 6.39999V11.7333C5.86668 11.8748 5.92286 12.0104 6.02288 12.1104Z"
				fill="currentColor"
			/>
			<path
				d="M9.60001 12.2667C9.45856 12.2667 9.3229 12.2104 9.22288 12.1104C9.12286 12.0104 9.06667 11.8748 9.06667 11.7333V6.39999C9.06667 6.25854 9.12286 6.12292 9.22288 6.0229C9.3229 5.92289 9.45856 5.86665 9.60001 5.86665C9.74146 5.86665 9.87711 5.92289 9.97713 6.0229C10.0772 6.12292 10.1333 6.25854 10.1333 6.39999V11.7333C10.1333 11.8748 10.0772 12.0104 9.97713 12.1104C9.87711 12.2104 9.74146 12.2667 9.60001 12.2667Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.4 0H9.60001C10.0242 0.000376592 10.431 0.169121 10.731 0.469097C11.0309 0.769074 11.1996 1.17577 11.2 1.6V2.13335H15.4667C15.6081 2.13335 15.7438 2.18958 15.8438 2.2896C15.9438 2.38961 16 2.52523 16 2.66668C16 2.80813 15.9438 2.94374 15.8438 3.04376C15.7438 3.14378 15.6081 3.20001 15.4667 3.20001H14.3572L13.413 14.533C13.3774 14.9321 13.1943 15.3036 12.8995 15.5749C12.6047 15.8461 12.2193 15.9977 11.8187 16H4.18203C3.78118 15.998 3.39553 15.8463 3.10063 15.5749C2.80572 15.3034 2.62282 14.9316 2.58773 14.5323L1.64286 3.20001H0.533333C0.391885 3.20001 0.256226 3.14378 0.156207 3.04376C0.0561872 2.94374 0 2.80813 0 2.66668C0 2.52523 0.0561872 2.38961 0.156207 2.2896C0.256226 2.18958 0.391885 2.13335 0.533333 2.13335H4.8V1.6C4.80038 1.17577 4.96906 0.769074 5.26904 0.469097C5.56901 0.169121 5.97577 0.000376592 6.4 0ZM10.1333 2.13333V1.6C10.1332 1.45861 10.0769 1.32307 9.97691 1.22309C9.87694 1.12311 9.7414 1.06685 9.60001 1.06667H6.4C6.25861 1.06685 6.12307 1.12311 6.0231 1.22309C5.92312 1.32307 5.86686 1.45861 5.86667 1.6V2.13333H10.1333ZM3.65369 14.4441L2.71645 3.20003H13.2907L12.3541 14.4441C12.3423 14.5773 12.2812 14.7012 12.1828 14.7917C12.0844 14.8822 11.9559 14.9326 11.8222 14.9334H4.18559C4.05146 14.9343 3.92198 14.8844 3.82326 14.7936C3.72454 14.7028 3.66394 14.5779 3.65369 14.4441Z"
				fill="currentColor"
			/>
		</svg>
	),
	WARNING: ({ color, height }) => (
		<>
			<svg height={height} color={color} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<path
					fill="currentColor"
					d="M12.0006 14.25C11.8017 14.25 11.6109 14.1709 11.4702 14.0303C11.3296 13.8896 11.2506 13.6989 11.2506 13.5V5.25C11.2506 5.05109 11.3296 4.86038 11.4702 4.71973C11.6109 4.57907 11.8017 4.5 12.0006 4.5C12.1995 4.5 12.3902 4.57907 12.5309 4.71973C12.6716 4.86038 12.7506 5.05109 12.7506 5.25V13.5C12.7506 13.6989 12.6716 13.8896 12.5309 14.0303C12.3902 14.1709 12.1995 14.25 12.0006 14.25Z"
				/>
				<path
					fill="currentColor"
					d="M12.0006 18C11.7781 18 11.5606 17.934 11.3756 17.8104C11.1906 17.6868 11.0464 17.5111 10.9612 17.3055C10.8761 17.1 10.8538 16.8737 10.8972 16.6555C10.9406 16.4373 11.0478 16.2368 11.2051 16.0795C11.3624 15.9221 11.5629 15.815 11.7811 15.7716C11.9993 15.7282 12.2255 15.7505 12.4311 15.8357C12.6367 15.9208 12.8124 16.065 12.936 16.25C13.0596 16.435 13.1256 16.6525 13.1256 16.875C13.1253 17.1733 13.0067 17.4592 12.7958 17.6702C12.5849 17.8811 12.2989 17.9997 12.0006 18Z"
				/>
				<path
					fill="currentColor"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.38771 21.2765C6.53388 23.0377 9.22431 24.0001 12.0006 24C13.577 24.0042 15.1387 23.6958 16.5951 23.0924C18.0516 22.4891 19.3739 21.6028 20.4856 20.485C22.4486 18.5218 23.6703 15.9387 23.9423 13.1758C24.2143 10.4129 23.5199 7.64111 21.9774 5.33278C20.4349 3.02445 18.1397 1.32242 15.483 0.516615C12.8262 -0.289192 9.97226 -0.148948 7.40737 0.913587C4.84247 1.97612 2.72534 3.89513 1.41672 6.34364C0.108097 8.79215 -0.311042 11.6187 0.230699 14.3416C0.772441 17.0645 2.24155 19.5154 4.38771 21.2765ZM6.16709 3.26954C7.8938 2.11579 9.92388 1.50001 12.0006 1.50001C14.7844 1.50319 17.4533 2.61043 19.4217 4.57887C21.3901 6.54731 22.4974 9.21622 22.5006 12C22.5006 14.0767 21.8848 16.1068 20.731 17.8335C19.5772 19.5602 17.9374 20.906 16.0188 21.7007C14.1001 22.4954 11.9889 22.7034 9.95214 22.2982C7.91533 21.8931 6.04441 20.893 4.57596 19.4246C3.10751 17.9561 2.10748 16.0853 1.70233 14.0485C1.29719 12.0117 1.50512 9.90045 2.29984 7.98182C3.09456 6.0632 4.44037 4.4233 6.16709 3.26954Z"
				/>
			</svg>
		</>
	),
	// WARNING_OLD:  ({ color, height }) => <></>,
	// WALLET:  ({ color, height }) => <></>,
	// WALLET_GREY:  ({ color, height }) => <></>,
	// X_ICON:  ({ color, height }) => <></>,
	// X_IN_CIRCLE:  ({ color, height }) => <></>,
	// BG:  ({ color, height }) => <></>,
	// PG:  ({ color, height }) => <></>,
	// SWIFT:  ({ color, height }) => <></>,
	// ALERT_SIGN:  ({ color, height }) => <></>,
	// ALERT_SIGN_INVERTED:  ({ color, height }) => <></>,
	// RED_WARNING_SIGN:  ({ color, height }) => <></>,
	// RED_TRIANGLE:  ({ color, height }) => <></>,
	// SUCCESS_CHECK_MARK:  ({ color, height }) => <></>,
	// SUCCESS_SIGN:  ({ color, height }) => <></>,
	// SUCCESS_SIGN_INVERTED:  ({ color, height }) => <></>,
	// YELLOW_WARNING_SIGN:  ({ color, height }) => <></>,
	ACCOUNTS: ({ color, height }) => (
		<svg viewBox="0 0 24 24" color={color} height={height}>
			<path
				fill="currentColor"
				d="M3.75 23.75A3.75 3.75 0 010 20V9.5a3.73 3.73 0 013.56-3.74L14.07.5a2.23 2.23 0 013.02 1l2.14 4.28A3.76 3.76 0 0122.5 9.5v.88c.89.31 1.5 1.16 1.5 2.12V17c0 .96-.61 1.8-1.5 2.12V20a3.75 3.75 0 01-3.75 3.75h-15zm0-16.5c-1.24 0-2.25 1-2.25 2.25V20c0 1.24 1 2.25 2.25 2.25h15c1.24 0 2.25-1.01 2.25-2.25v-.75h-3a4.5 4.5 0 010-9h3V9.5c0-1.24-1-2.25-2.25-2.25h-15zM18 11.75a3 3 0 000 6h3.75c.41 0 .75-.34.75-.75v-4.5a.75.75 0 00-.75-.75H18zm-.46-6l-1.79-3.57a.74.74 0 00-1-.34l-7.82 3.9h10.6z"
			/>
			<circle fill="currentColor" cx="18" cy="14.75" r="1.13" />
		</svg>
	),
	BUSINESS_ACCOUNT: ({ color, height }) => (
		<svg viewBox="0 0 20 20" color={color} height={height}>
			<g fill="none" fillRule="evenodd">
				<path d="M0 0h20v20H0z" />
			</g>
			<g fill="currentColor">
				<path d="M16.01 13v2.016h-2.02V13h2.02zm0-3.984v1.968h-2.02V9.016h2.02zm2.019 7.968V7H10v2.016h2.02v1.968H10V13h2.02v2.016H10v1.968h8.029zm-10.048-12V3.016H6.01v1.968h1.97zm0 4.032V7H6.01v2.016h1.97zm0 3.984v-2.016H6.01V13h1.97zm0 3.984v-1.968H6.01v1.968h1.97zm-3.99-12V3.016H1.97v1.968h2.02zm0 4.032V7H1.97v2.016h2.02zm0 3.984v-2.016H1.97V13h2.02zm0 3.984v-1.968H1.97v1.968h2.02zm6.009-12h10V19H0V1h10v3.984z" />
			</g>
		</svg>
	),
	CONTACT_CARD: ({ color, height }) => (
		<svg color={color} height={height} viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M5.25 24a3 3 0 01-3-3V3.75A3.75 3.75 0 016 0h13.5c1.24 0 2.25 1 2.25 2.25v15c0 .96-.61 1.8-1.5 2.12v3.13H21a.75.75 0 010 1.5H5.25zm0-4.5a1.5 1.5 0 000 3h13.5v-3H5.25zM6 1.5c-1.24 0-2.25 1-2.25 2.25V18.4c.45-.26.96-.4 1.5-.4H19.5c.41 0 .75-.34.75-.75v-15a.75.75 0 00-.75-.75H6z"
			/>
			<path
				fill="currentColor"
				d="M12 11.25a3.38 3.38 0 110-6.76 3.38 3.38 0 010 6.76zM12 6a1.88 1.88 0 100 3.75A1.88 1.88 0 0012 6z"
			/>
			<path
				fill="currentColor"
				d="M16.5 16.5a.75.75 0 01-.75-.75 3.75 3.75 0 00-7.5 0 .75.75 0 01-1.5 0 5.26 5.26 0 0110.5 0c0 .41-.34.75-.75.75z"
			/>
		</svg>
	),
	DASHBOARD: ({ color, height }) => (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" color={color} height={height}>
			<path
				fill="currentColor"
				d="M4.46 21.92a.75.75 0 01-.75-.75V10.98L1.99 12.7a.74.74 0 01-1.06 0 .74.74 0 010-1.06l9.43-9.44a2.24 2.24 0 013.18 0L23 11.64a.75.75 0 01-1.06 1.07l-1.72-1.72v10.18c0 .42-.34.75-.75.75h-15zm14.25-1.5V9.5l-6.23-6.23a.75.75 0 00-1.05 0L5.2 9.48v10.94h3v-3.75a3.75 3.75 0 017.5 0v3.75h3zm-4.5 0v-3.75a2.25 2.25 0 00-4.5 0v3.75h4.5z"
			/>
		</svg>
	),
	E_INVOICE: ({ color, height }) => (
		<svg color={color} height={height} viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M12 24c-.4 0-.9-.2-1.2-.5-9.3-8.5-9.3-8.2-9.4-8.2-.8-1-.8-2.1-.8-2.3V4.4C.6 2.1 2.5.3 4.7.3h14.4c2.3 0 4.1 1.9 4.1 4.1V13c0 .4 0 .7-.1 1.1-.2.7-.6 1.4-1.2 1.9l-8.8 7.6c-.2.3-.7.4-1.1.4zM4.8 1.9a2.6 2.6 0 00-2.7 2.6v8.7c0 .1 0 .7.4 1.2.1.1 6.1 5.2 9.3 8.1.1.1.3.1.4 0l8.8-7.6c.3-.3.6-.8.7-1.2.1-.2.1-.5.1-.7V4.5c0-1.5-1.2-2.6-2.6-2.6H4.8z"
			/>
			<path
				fill="currentColor"
				d="M9.4 13.2c-.7-.7-1-1.7-1-3 0-1.5.3-2.5 1-3.2.7-.7 1.6-1 2.8-1 1.2 0 2 .4 2.5 1.1.5.7.8 1.7.8 2.9 0 .1-.1.3-.3.6-.2.2-.4.4-.5.4h-4c.1.6.2 1 .5 1.3.3.2.7.4 1.3.4.3 0 .6 0 .8-.1.2-.1.5-.2.7-.3.2-.1.3-.1.3-.1.1 0 .2.1.4.2.1.2.2.3.3.5.1.2.1.3.1.4 0 .2-.2.4-.5.6s-.7.3-1.2.4c-.4.1-.8.1-1.2.1a4.5 4.5 0 01-2.8-1.2zm3.9-3.9c0-.5-.1-.9-.3-1.1a.9.9 0 00-.8-.4c-.8 0-1.2.5-1.4 1.6h2.5z"
			/>
		</svg>
	),
	AUTOGIRO: ({ color, height }) => (
		<svg color={color} height={height} viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M12 24c-.4 0-.9-.2-1.2-.5-9.3-8.5-9.3-8.2-9.4-8.2-.8-1-.8-2.1-.8-2.3V4.4C.6 2.1 2.5.3 4.7.3h14.4c2.3 0 4.1 1.9 4.1 4.1V13c0 .4 0 .7-.1 1.1-.2.7-.6 1.4-1.2 1.9l-8.8 7.6c-.2.3-.7.4-1.1.4zM4.8 1.9a2.6 2.6 0 00-2.7 2.6v8.7c0 .1 0 .7.4 1.2.1.1 6.1 5.2 9.3 8.1.1.1.3.1.4 0l8.8-7.6c.3-.3.6-.8.7-1.2.1-.2.1-.5.1-.7V4.5c0-1.5-1.2-2.6-2.6-2.6H4.8z"
			/>
			<path
				fill="currentColor"
				d="M17.3 10.8c0-1-.3-2-.8-2.8 0 0-.1-.1-.2-.1-.3 0-.7.3-.9.5-.1.1 0 .2 0 .2a4.23 4.23 0 01-3.6 6.4h-.4l.7-.8c.1-.1.2-.3.2-.5s-.1-.3-.2-.4c-.1-.1-.3-.2-.4-.2-.2 0-.3.1-.4.2l-1.8 1.9c-.2.2-.2.5 0 .7l1.7 2c.1.1.3.2.5.2.1 0 .3-.1.4-.2.3-.2.3-.6 0-.9l-.6-.8h.4c3 0 5.4-2.4 5.4-5.4zM11.9 6.6h.3l-.7.9c-.1.1-.2.3-.2.4 0 .2.1.3.2.4.1.1.3.2.4.2.2 0 .3-.1.4-.2l1.7-2c.2-.2.2-.5 0-.7l-1.7-2c-.1-.1-.3-.2-.5-.2-.1 0-.2 0-.3.1-.2.1-.3.3-.3.4 0 .2 0 .4.2.5l.7.8h-.3A5.38 5.38 0 007 13c.1.1.2.2.3.2.3 0 .6-.2.8-.4.1-.2.1-.3 0-.3-.3-.6-.4-1.2-.4-1.8 0-2.2 1.9-4.1 4.2-4.1z"
			/>
		</svg>
	),
	FACE: ({ color, height }) => (
		<svg viewBox="0 0 20 20" color={color} height={height}>
			<g fill="" fillRule="evenodd">
				<g fill="currentColor">
					<path
						id="a"
						d="M10 16.68c1.2 0 2.32-.307 3.36-.92a6.477 6.477 0 0 0 2.4-2.4c.613-1.04.92-2.16.92-3.36 0-.573-.093-1.2-.28-1.88-.48.133-1.1.2-1.86.2a8.12 8.12 0 0 1-3.88-.96A8.165 8.165 0 0 1 7.74 4.8c-.413 1-1 1.893-1.76 2.68A8.062 8.062 0 0 1 3.36 9.3c-.027.16-.04.393-.04.7 0 1.2.307 2.32.92 3.36a6.477 6.477 0 0 0 2.4 2.4c1.04.613 2.16.92 3.36.92zm0-15c1.52 0 2.927.38 4.22 1.14a7.886 7.886 0 0 1 2.96 2.96A8.182 8.182 0 0 1 18.32 10c0 1.52-.38 2.927-1.14 4.22a7.886 7.886 0 0 1-2.96 2.96A8.182 8.182 0 0 1 10 18.32c-1.52 0-2.927-.38-4.22-1.14a8.035 8.035 0 0 1-2.96-2.98A8.146 8.146 0 0 1 1.68 10c0-1.507.38-2.907 1.14-4.2A8.188 8.188 0 0 1 5.8 2.82 8.146 8.146 0 0 1 10 1.68zm2.5 8.12c.293 0 .543.097.75.29.207.193.31.437.31.73s-.103.543-.31.75c-.207.207-.457.31-.75.31s-.543-.103-.75-.31a1.022 1.022 0 0 1-.31-.75c0-.293.103-.537.31-.73.207-.193.457-.29.75-.29zm-5 0c.293 0 .543.097.75.29.207.193.31.437.31.73s-.103.543-.31.75c-.207.207-.457.31-.75.31s-.543-.103-.75-.31a1.022 1.022 0 0 1-.31-.75c0-.293.103-.537.31-.73.207-.193.457-.29.75-.29z"
					/>
				</g>
			</g>
		</svg>
	),
	FILE: ({ color, height }) => (
		<svg color={color} height={height} viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M23.25 19.5a.75.75 0 01-.75-.75V5.12c0-.2-.08-.39-.22-.53l-2.87-2.87a.75.75 0 00-.53-.22H8.25a.75.75 0 00-.75.75V12A.75.75 0 016 12V2.25C6 1.01 7 0 8.25 0h10.63c.6 0 1.16.23 1.59.66l2.87 2.87c.43.43.66.99.66 1.6v13.62c0 .41-.34.75-.75.75zM.75 24a.75.75 0 010-1.5h3c.41 0 .75-.34.75-.75v-6a.75.75 0 00-.75-.75h-3a.75.75 0 010-1.5h3c.96 0 1.8.61 2.12 1.5h4.63c1.8 0 3.32 1.27 3.67 3h3.08A3.75 3.75 0 0121 21.75c0 .41-.34.75-.75.75H5.87A2.26 2.26 0 013.75 24h-3zm18.62-3a2.26 2.26 0 00-2.12-1.5H10.5a.75.75 0 010-1.5h2.12a2.26 2.26 0 00-2.12-1.5H6V21h13.37z"
			/>
			<circle fill="currentColor" cx="2.63" cy="19.88" r="1.13" />
		</svg>
	),
	INBOX: ({ color, height }) => (
		<svg color={color} height={height} viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M3 24c-1.24 0-2.25-1-2.25-2.25v-4.5C.75 16.01 1.75 15 3 15h3.83c.27 0 .52.14.65.38a5.2 5.2 0 009.04 0 .75.75 0 01.65-.38H21c1.24 0 2.25 1 2.25 2.25v4.5c0 1.24-1 2.25-2.25 2.25H3zm0-7.5a.75.75 0 00-.75.75v4.5c0 .41.34.75.75.75h18c.41 0 .75-.34.75-.75v-4.5a.75.75 0 00-.75-.75h-3.41a6.66 6.66 0 01-8.91 2.12A6.71 6.71 0 016.4 16.5H3zM19.5 13.5a.75.75 0 01-.75-.75V2.25A.75.75 0 0018 1.5H6a.75.75 0 00-.75.75v10.5a.75.75 0 01-1.5 0V2.25C3.75 1.01 4.75 0 6 0h12c1.24 0 2.25 1 2.25 2.25v10.5c0 .41-.34.75-.75.75z"
			/>
			<path
				fill="currentColor"
				d="M8.25 6a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3zM8.25 9a.75.75 0 010-1.5h7.5a.75.75 0 010 1.5h-7.5zM8.25 12a.75.75 0 010-1.5h7.5a.75.75 0 010 1.5h-7.5z"
			/>
		</svg>
	),
	MOBILE_PAY: ({ color, height }) => (
		<svg viewBox="0 0 24 24" color={color} height={height}>
			<path
				fill="currentColor"
				d="M22.13 24a.75.75 0 01-.63-.33l-3-4.5a.75.75 0 01-.12-.42V13.5c0-1.19-2.3-2.8-3.75-3.8v3.19l1.64 1.32a.75.75 0 01-.93 1.17l-1.9-1.51a.74.74 0 01-.07-.07l-1.68-1.34a.66.66 0 01-.06-.06c-.1-.1-.24-.15-.4-.15a.54.54 0 00-.55.54c0 .15.06.29.16.4l3.57 4.01c.12.14.19.32.19.5v2.5c0 .62.87 1.86 1.5 2.54a.75.75 0 01-1.12 1c-.14-.14-.76-.85-1.25-1.7-.39.3-.86.46-1.36.46h-9c-1.24 0-2.25-1-2.25-2.25v-18C1.12 1.01 2.13 0 3.37 0h9c1.25 0 2.26 1 2.26 2.25v5.62c.2.15.44.32.72.5 1.91 1.32 4.53 3.12 4.53 5.13v5.02l2.87 4.32a.75.75 0 01-.63 1.16zM3.38 1.5a.75.75 0 00-.75.75v18c0 .41.33.75.75.75h9c.35 0 .66-.26.73-.6l-.01-.2v-2.21L9.75 14.2a2.04 2.04 0 011.48-3.47c.54 0 1.04.2 1.42.57l.47.37V2.25a.75.75 0 00-.75-.75h-9z"
			/>
			<path
				fill="currentColor"
				d="M7.87 15a3.73 3.73 0 01-3.74-3.76A3.72 3.72 0 017.88 7.5c1.07 0 2.08.46 2.8 1.25a.74.74 0 01-.06 1.06.75.75 0 01-1.06-.06 2.25 2.25 0 10-1.68 3.75c.4 0 .75.34.74.75 0 .41-.75.75-.75.75z"
			/>
			<circle fill="currentColor" cx="4.5" cy="3.38" r="1.13" />
			<circle fill="currentColor" cx="11.25" cy="19.13" r="1.13" />
		</svg>
	),
	MONEY: ({ color, height }) => (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" color={color} height={height}>
			<g transform="translate(.75 .75)">
				<g transform="translate(-540.75 -241.75)">
					<path
						fill="none"
						d="M546.75 247.75c3.314 0 6-1.343 6-3s-2.686-3-6-3-6 1.343-6 3 2.686 3 6 3z"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.5px"
					/>
					<path
						fill="none"
						d="M552.75 247.75c0 1.657-2.686 3-6 3s-6-1.343-6-3"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.5px"
					/>
					<path
						fill="none"
						d="M552.75 250.75v-6"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.5px"
					/>
					<path
						fill="none"
						d="M540.75 244.75v15c0 1.657 2.686 3 6 3a11.333 11.333 0 002.25-.223"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.5px"
					/>
					<path
						fill="none"
						d="M540.75 256.75c0 1.657 2.686 3 6 3a11.333 11.333 0 002.25-.223"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.5px"
					/>
					<path
						fill="none"
						d="M540.75 253.75c0 1.657 2.686 3 6 3a11.333 11.333 0 002.25-.223"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.5px"
					/>
					<path
						fill="none"
						d="M540.75 250.75c0 1.657 2.686 3 6 3a11.332 11.332 0 002.25-.223"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.5px"
					/>
					<path
						d="M557.25 258.25c3.314 0 6-1.343 6-3s-2.686-3-6-3-6 1.343-6 3 2.686 3 6 3z"
						fill="none"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.5px"
					/>
					<path
						d="M551.25 255.25v6c0 1.657 2.686 3 6 3s6-1.343 6-3v-6"
						fill="none"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.5px"
					/>
					<path
						d="M563.25 258.25c0 1.657-2.686 3-6 3s-6-1.343-6-3"
						fill="none"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.5px"
					/>
				</g>
			</g>
		</svg>
	),
	PAY: ({ color, height }) => (
		<svg viewBox="0 0 24 24" color={color} height={height}>
			<path
				fill="currentColor"
				d="M14.25 12a.74.74 0 01-.53-.22.74.74 0 010-1.06L15.44 9H9a.75.75 0 010-1.5h6.44l-1.72-1.72a.74.74 0 010-1.06.75.75 0 011.06 0l3 3c.07.07.12.15.16.24l.01.03a.73.73 0 010 .52v.01c-.05.1-.1.19-.17.26l-3 3a.74.74 0 01-.53.22zM9.75 19.5a.74.74 0 01-.53-.22l-3-3a.75.75 0 01-.16-.24L6.05 16a.73.73 0 010-.52l.01-.03a.75.75 0 01.16-.24l3-3a.75.75 0 011.06 0c.3.3.3.77 0 1.06L8.56 15H15a.75.75 0 010 1.5H8.56l1.72 1.72a.75.75 0 01-.53 1.28z"
			/>
			<path
				fill="currentColor"
				d="M3.75 24A3.75 3.75 0 010 20.25V3.75A3.75 3.75 0 013.75 0h16.5A3.75 3.75 0 0124 3.75v16.5A3.75 3.75 0 0120.25 24H3.75zm0-22.5c-1.24 0-2.25 1-2.25 2.25v16.5c0 1.24 1 2.25 2.25 2.25h16.5c1.24 0 2.25-1 2.25-2.25V3.75c0-1.24-1-2.25-2.25-2.25H3.75z"
			/>
		</svg>
	),
	ROLES: ({ color, height }) => (
		<svg viewBox="0 0 20 20" color={color} height={height}>
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<path
					fill="#00325C"
					d="M10,3 C8.300781,3 7,4.300781 7,6 C7,7.699219 8.300781,9 10,9 C11.699219,9 13,7.699219 13,6 C13,4.300781 11.699219,3 10,3 Z M3.5,5 C2.121094,5 1,6.121094 1,7.5 C1,8.878906 2.121094,10 3.5,10 C4.878906,10 6,8.878906 6,7.5 C6,6.121094 4.878906,5 3.5,5 Z M16.5,5 C15.121094,5 14,6.121094 14,7.5 C14,8.878906 15.121094,10 16.5,10 C17.878906,10 19,8.878906 19,7.5 C19,6.121094 17.878906,5 16.5,5 Z M10,11 C5.398438,11 4,14.3125 4,14.3125 L4,12 L3.5,12 C0,12 -1,14.6875 -1,14.6875 L-1,17 L21,17 L21,14.6875 C21,14.6875 20,12 16.5,12 L16,12 L16,14.3125 C16,14.3125 14.601563,11 10,11 Z"
					id="path-1"
				/>
				<rect id="Rectangle" x="0" y="0" width="20" height="20" />
			</g>
		</svg>
	),
	// SETTINGS:  ({ color, height }) => <></>,
	UPCOMING_PAYMENTS: ({ color, height }) => (
		<svg color={color} height={height} viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M3 24c-1.24 0-2.25-1-2.25-2.25v-4.5C.75 16.01 1.75 15 3 15h3.83c.27 0 .52.14.65.38a5.2 5.2 0 009.04 0 .75.75 0 01.65-.38H21c1.24 0 2.25 1 2.25 2.25v4.5c0 1.24-1 2.25-2.25 2.25H3zm0-7.5a.75.75 0 00-.75.75v4.5c0 .41.34.75.75.75h18c.41 0 .75-.34.75-.75v-4.5a.75.75 0 00-.75-.75h-3.41a6.66 6.66 0 01-8.91 2.12A6.71 6.71 0 016.4 16.5H3zM19.5 13.5a.75.75 0 01-.75-.75V2.25A.75.75 0 0018 1.5H6a.75.75 0 00-.75.75v10.5a.75.75 0 01-1.5 0V2.25C3.75 1.01 4.75 0 6 0h12c1.24 0 2.25 1 2.25 2.25v10.5c0 .41-.34.75-.75.75z"
			/>
			<path
				fill="currentColor"
				d="M12 13.5a.75.75 0 01-.75-.75v-.35a2.98 2.98 0 01-1.7-1.1.74.74 0 01.14-1.05c.13-.1.29-.16.45-.16.23 0 .46.11.6.3.27.36.71.58 1.17.58h.06c.77 0 1.34-.42 1.34-.8 0-.38-.56-.8-1.31-.8-1.55 0-2.81-1.03-2.81-2.3 0-1.05.85-1.94 2.06-2.2V4.5a.75.75 0 011.5 0v.36c.68.15 1.28.54 1.7 1.1a.75.75 0 01-1.19.9 1.48 1.48 0 00-1.17-.58h-.06c-.78 0-1.34.42-1.34.8 0 .38.56.8 1.31.8 1.55 0 2.81 1.03 2.81 2.3 0 1.04-.85 1.94-2.06 2.2v.37c0 .41-.34.75-.75.75z"
			/>
		</svg>
	),
	USER_ACCOUNT: ({ color, height }) => (
		<svg viewBox="0 0 20 20" color={color} height={height}>
			<g fill="#fff">
				<path d="M0 0h20v20H0z" />
			</g>
			<g fill="currentColor" fillRule="evenodd">
				<path
					id="a"
					d="M10 17.236a6.858 6.858 0 0 0 3.438-.914 7.178 7.178 0 0 0 2.572-2.332c-.016-.609-.393-1.17-1.13-1.682-.641-.433-1.459-.786-2.452-1.058-.898-.24-1.71-.36-2.44-.36s-1.542.12-2.44.36c-.994.272-1.803.625-2.428 1.058-.737.513-1.114 1.073-1.13 1.682a7.178 7.178 0 0 0 2.572 2.332 6.946 6.946 0 0 0 3.438.914zm0-14.231c-.529 0-1.026.136-1.49.408A3.048 3.048 0 0 0 7.404 4.52a2.899 2.899 0 0 0-.409 1.49c0 .53.136 1.026.409 1.491.272.465.64.833 1.106 1.106.464.272.961.408 1.49.408s1.026-.136 1.49-.408A3.048 3.048 0 0 0 12.596 7.5c.273-.465.409-.962.409-1.49 0-.53-.136-1.026-.409-1.49a3.048 3.048 0 0 0-1.106-1.107A2.899 2.899 0 0 0 10 3.005zM10 0c1.827 0 3.518.457 5.072 1.37a9.478 9.478 0 0 1 3.558 3.558A9.835 9.835 0 0 1 20 10a9.835 9.835 0 0 1-1.37 5.072 9.478 9.478 0 0 1-3.558 3.558A9.835 9.835 0 0 1 10 20a9.835 9.835 0 0 1-5.072-1.37 9.657 9.657 0 0 1-3.558-3.582A9.79 9.79 0 0 1 0 10a9.79 9.79 0 0 1 1.37-5.048A9.842 9.842 0 0 1 4.952 1.37 9.79 9.79 0 0 1 10 0z"
				/>
			</g>
		</svg>
	),
	SHOW_MORE: ({ color, height }) => (
		<svg color={color} height={height} viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M3.38 15.4a3.38 3.38 0 110-6.76 3.38 3.38 0 010 6.76zm0-5.25a1.88 1.88 0 100 3.75 1.88 1.88 0 000-3.75zM20.63 15.4a3.38 3.38 0 110-6.76 3.38 3.38 0 010 6.76zm0-5.25a1.88 1.88 0 100 3.75 1.88 1.88 0 000-3.75zM12 15.4a3.38 3.38 0 110-6.76 3.38 3.38 0 010 6.76zm0-5.25a1.88 1.88 0 100 3.75 1.88 1.88 0 000-3.75z"
			/>
		</svg>
	),
	LOANS: ({ color, height }) => (
		<svg color={color} height={height} viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M6.75 24C2.9 24 0 22.39 0 20.25v-6c0-2.14 2.9-3.75 6.75-3.75s6.75 1.61 6.75 3.75v6c0 2.14-2.9 3.75-6.75 3.75zM1.5 20.25c0 1.06 2.25 2.25 5.25 2.25S12 21.31 12 20.25v-.6C10.75 20.51 8.86 21 6.75 21s-4-.5-5.25-1.35v.6zm0-3c0 1.06 2.25 2.25 5.25 2.25S12 18.31 12 17.25v-.6C10.75 17.51 8.86 18 6.75 18s-4-.5-5.25-1.35v.6zM6.75 12c-3 0-5.25 1.19-5.25 2.25s2.25 2.25 5.25 2.25S12 15.31 12 14.25 9.76 12 6.75 12z"
			/>
			<path
				fill="currentColor"
				d="M15.75 16.5a.75.75 0 010-1.5h6c.41 0 .75-.34.75-.75v-12a.75.75 0 00-.75-.75H2.25a.75.75 0 00-.75.75v7.5a.75.75 0 01-1.5 0v-7.5C0 1.01 1 0 2.25 0h19.5C22.99 0 24 1 24 2.25v12c0 1.24-1 2.25-2.25 2.25h-6z"
			/>
			<path
				fill="currentColor"
				d="M13.98 11.26a.75.75 0 01-.5-1.32 2.25 2.25 0 10-3.73-1.69.75.75 0 01-1.5 0A3.72 3.72 0 0112 4.5a3.72 3.72 0 013.75 3.75c0 1.08-.46 2.1-1.28 2.82a.75.75 0 01-.5.19z"
			/>
			<circle fill="currentColor" cx="4.5" cy="4.5" r="1.13" />
			<circle fill="currentColor" cx="19.5" cy="12" r="1.13" />
		</svg>
	),
	ADD_PRODUCTS: ({ color, height }) => (
		<svg viewBox="0 0 20 20" color={color} height={height}>
			<g fill="none" fillRule="evenodd">
				<path
					fill="currentColor"
					id="a"
					d="M4.094 0c-.7 0-1.29.398-1.688 1L.187 4.594C.086 4.793 0 5.199 0 5.5V16c0 1.102.898 2 2 2h16c1.102 0 2-.898 2-2V5.5c0-.3-.086-.707-.188-.906L17.595 1c-.399-.602-.989-1-1.688-1H4.094zm-.188 2H9v3H2.187l1.72-3zM11 2h5.094l1.718 3H11V2zM7 7h6c.602 0 1 .398 1 1s-.398 1-1 1H7c-.602 0-1-.398-1-1s.398-1 1-1z"
				/>
				<path d="M0-1h20v20H0z" />
			</g>
		</svg>
	),
	// INTERNATIONAL_PAYMENTS:  ({ color, height }) => <></>,
	ROLE_PREPARE: ({ height }) => (
		<svg version="1.1" height={height} viewBox="0 0 393 393" x="0px" y="0px">
			<circle fill="#F6F6F1" cx="196.5" cy="196.5" r="196.5" />

			<g>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					fill="#434343"
					d="M196.5,144.7c0,20.5-16.6,37.1-37.1,37.1s-37.1-16.6-37.1-37.1s16.6-37.1,37.1-37.1
					S196.5,124.2,196.5,144.7L196.5,144.7z M140.2,136.6c-1.1,0.5-1.9,1.4-2.2,2.5c-0.5,1.8-0.7,3.6-0.7,5.5
					c0.1,12.3,10.1,22.2,22.4,22.1c10.8-0.1,20-7.9,21.8-18.5c0.1-1.1-0.2-2.3-1.1-3.1c-0.8-0.8-2-1.2-3.2-1
					c-2.3,0.4-4.6,0.5-6.9,0.5c-9.5-0.1-18.7-2.7-26.8-7.7C142.5,136.3,141.2,136.2,140.2,136.6L140.2,136.6z"
				/>
				<path
					fill="#434343"
					d="M178,200.2c0-2.6,0.5-5.1,1.4-7.5c0.4-0.9,0.3-2-0.1-2.9c-0.4-0.9-1.2-1.6-2.2-1.9
					c-5.2-1.7-10.6-2.5-16-2.5c-24.6,0.1-46.2,16.2-53.3,39.7c-0.3,1.1-0.1,2.3,0.6,3.3c0.7,0.9,1.8,1.5,3,1.5h63
					c2,0,3.7-1.7,3.7-3.7l0,0L178,200.2z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					fill="#434343"
					d="M270.6,189.1c8.2,0,14.8,6.6,14.8,14.8l0,0v66.7c0,8.2-6.6,14.8-14.8,14.8l0,0h-66.7
					c-8.2,0-14.8-6.6-14.8-14.8l0,0v-66.7c0-8.2,6.6-14.8,14.8-14.8l0,0H270.6z M205.8,203.9c-1,0-1.8,0.8-1.8,1.8v63
					c0,1,0.8,1.8,1.8,1.8h63c0.5,0,1-0.2,1.3-0.5c0.3-0.4,0.5-0.8,0.5-1.3v-63c0-1-0.8-1.9-1.8-1.9c0,0,0,0,0,0H205.8L205.8,203.9z"
				/>
				<path
					fill="#434343"
					d="M255.8,218.7h-35.2c-3.1,0.1-5.4,2.7-5.3,5.8c0.1,2.9,2.4,5.2,5.3,5.3h35.2
					c3.1-0.1,5.4-2.7,5.3-5.8C261,221.2,258.7,218.9,255.8,218.7L255.8,218.7z"
				/>
				<path
					fill="#434343"
					d="M237.3,252.1c3.1-0.1,5.4-2.7,5.3-5.8c-0.1-2.9-2.4-5.2-5.3-5.3h-16.7
					c-3.1,0.1-5.4,2.7-5.3,5.8c0.1,2.9,2.4,5.2,5.3,5.3H237.3z"
				/>
			</g>
		</svg>
	),
	ROLE_APPROVE: ({ height }) => (
		<svg version="1.1" x="0px" y="0px" viewBox="0 0 393 393" height={height}>
			<circle fill="#F6F6F1" cx="196.5" cy="196.5" r="196.5" />

			<g>
				<path
					fill="#434343"
					d="M283.9,201.1c-0.8-0.7-1.8-1.2-2.8-1.3c-2.8-1.2-6-0.7-8.2,1.4L238.6,234
						c-0.7,0.7-1.9,0.7-2.6,0l-8.7-8.3c-3-2.7-7.5-2.7-10.5,0c-2.8,2.6-2.9,7-0.3,9.8l0.3,0.3l11.7,11.3c5,4.7,12.7,4.7,17.7,0
						l37.2-35.8c1.5-1.5,2.3-3.6,2-5.7C285.7,204,285.1,202.3,283.9,201.1z"
				/>
				<path
					fill="#434343"
					d="M278.5,240.5c-1.9-0.5-3.9-0.3-5.7,0.5c-1.7,0.8-3,2.3-3.6,4.1c-5.5,16-22.1,25.3-38.6,21.8
						c-16.5-2.9-28-18-26.5-34.6c2.1-16.7,16.4-29.1,33.2-28.8c3.9,0.5,7.5-2.2,8-6.1c0.5-3.9-2.2-7.5-6.1-8c-0.4-0.1-0.8-0.1-1.3-0.1
						h-0.7c-24.3-0.4-45,17.5-48,41.6c-2.2,24.1,14.5,45.8,38.3,50c23.8,5,47.7-8.4,55.7-31.4c1.2-3.7-0.9-7.7-4.6-8.9L278.5,240.5z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					fill="#434343"
					d="M196.6,146.6c0.8,20.5-15.1,37.7-35.6,38.5c-20.5,0.8-37.7-15.1-38.5-35.6
						c-0.8-20.5,15.1-37.7,35.6-38.5c0,0,0,0,0,0c0.5,0,1,0,1.5,0C179.5,110.7,196.1,126.6,196.6,146.6
						C196.5,146.6,196.5,146.6,196.6,146.6L196.6,146.6z M140.2,139c-1.1,0.4-1.9,1.3-2.2,2.4c-0.5,1.7-0.7,3.5-0.7,5.3
						c0.3,11.3,9.1,20.5,20.4,21.2c11.3,1.1,21.6-6.6,23.8-17.7c0.2-1.1-0.2-2.2-1.1-3c-0.8-0.8-2-1.2-3.2-1c-2.3,0.4-4.6,0.5-6.9,0.5
						c-9.4,0-18.7-2.6-26.8-7.4C142.5,138.6,141.2,138.5,140.2,139L140.2,139z"
				/>
				<path
					fill="#434343"
					d="M192.4,196.6c-0.2-1-0.8-1.9-1.7-2.4c-14.8-9.1-32.9-10.9-49.3-5
						c-16.1,5.6-28.6,18.5-33.8,34.8c-0.3,1.1-0.1,2.3,0.6,3.2c0.7,0.9,1.8,1.4,3,1.4h64.1c1.7,0,3.3-1.2,3.6-2.9
						c1.8-9.7,6.2-18.7,12.6-26.2C192.3,198.6,192.6,197.6,192.4,196.6z"
				/>
			</g>
		</svg>
	),
	ROLE_FULL: ({ height }) => (
		<svg version="1.1" x="0px" y="0px" viewBox="0 0 393 393" height={height}>
			<circle fill="#F6F6F1" cx="196.5" cy="196.5" r="196.5" />

			<g>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					fill="#434343"
					d="M196.5,146.6c0,19.7-15.9,35.6-35.6,35.6s-35.6-15.9-35.6-35.6s15.9-35.6,35.6-35.6
			   S196.5,127,196.5,146.6L196.5,146.6z M142.4,138.9c-1,0.4-1.8,1.3-2.1,2.4c-0.5,1.7-0.7,3.5-0.7,5.3c0.1,11.8,9.7,21.3,21.5,21.2
			   c10.4-0.1,19.2-7.5,20.9-17.7c0.1-1.1-0.2-2.2-1-3c-0.8-0.8-1.9-1.2-3-1c-2.2,0.3-4.4,0.5-6.6,0.5c-9.1-0.1-18-2.6-25.8-7.4
			   C144.6,138.6,143.4,138.5,142.4,138.9L142.4,138.9z"
				/>
				<path
					fill="#434343"
					d="M180.1,219.2c3-7.3,10.2-12.1,18.2-12c1.2,0,2.3-0.7,2.8-1.8c0.5-1.1,0.2-2.4-0.6-3.2
			   c-20.4-21.1-54-21.8-75.2-1.4c-6.6,6.4-11.5,14.4-14.1,23.3c-0.5,1.9,0.6,3.9,2.5,4.4c0.3,0.1,0.6,0.1,0.9,0.1h60.6
			   c1.9,0,3.5-1.5,3.6-3.3C178.9,223.1,179.4,221.1,180.1,219.2z"
				/>
				<path
					fill="#434343"
					d="M258.8,280.8c3.4,2,7.8,1.5,10.7-1.2c2.9-2.6,3.8-6.8,2.3-10.3l-8.7-20
			   c-0.3-0.7-0.1-1.5,0.5-2.1l15.8-14c2.7-2.5,3.5-6.4,2.1-9.8c-1.4-3.3-4.7-5.5-8.3-5.4h-17.8c-0.7,0-1.4-0.4-1.6-1.1l-9.5-22.2
			   l-0.1-0.2c-2.4-4.5-8-6.3-12.5-3.9c-1.7,0.9-3.1,2.4-4,4.1l-9.6,22.2c-0.3,0.7-0.9,1.1-1.6,1.1h-17.8c-3.6-0.1-7,2.1-8.3,5.4
			   c-1.4,3.5-0.5,7.4,2.3,10l15.7,13.9c0.6,0.5,0.8,1.3,0.5,2.1l-8.7,20c-1.6,3.6-0.7,7.7,2.2,10.3c2.9,2.7,7.3,3.1,10.7,1.2
			   l22.2-12.5c0.5-0.3,1.2-0.3,1.7,0L258.8,280.8z"
				/>
			</g>
		</svg>
	),
	HAMBURGER: ({ color, height }) => (
		<svg
			height={height}
			viewBox="0 0 21 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			color={color}
		>
			<path
				d="M0.750005 12.75H20.25"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M0.750005 6.75H20.25"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M0.750005 0.75H20.25"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	INFO_DETAILS: ({ color, height }) => (
		<svg
			color={color}
			height={height}
			viewBox="0 0 31 38"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={{ transform: "translateY(-5px)" }}
		>
			<path
				d="M21.984 17.3558H8.09936C7.79249 17.3558 7.49818 17.2339 7.28119 17.0169C7.0642 16.7999 6.9423 16.5056 6.9423 16.1987C6.9423 15.8918 7.0642 15.5975 7.28119 15.3806C7.49818 15.1636 7.79249 15.0417 8.09936 15.0417H21.984C22.2908 15.0417 22.5851 15.1636 22.8021 15.3806C23.0191 15.5975 23.141 15.8918 23.141 16.1987C23.141 16.5056 23.0191 16.7999 22.8021 17.0169C22.5851 17.2339 22.2908 17.3558 21.984 17.3558Z"
				fill={color}
			/>
			<path
				d="M21.984 23.1411H8.09936C7.79249 23.1411 7.49818 23.0192 7.28119 22.8022C7.0642 22.5852 6.9423 22.2909 6.9423 21.984C6.9423 21.6771 7.0642 21.3828 7.28119 21.1658C7.49818 20.9489 7.79249 20.827 8.09936 20.827H21.984C22.2908 20.827 22.5851 20.9489 22.8021 21.1658C23.0191 21.3828 23.141 21.6771 23.141 21.984C23.141 22.2909 23.0191 22.5852 22.8021 22.8022C22.5851 23.0192 22.2908 23.1411 21.984 23.1411Z"
				fill={color}
			/>
			<path
				d="M8.09936 28.9263H21.984C22.2908 28.9263 22.5851 28.8044 22.8021 28.5874C23.0191 28.3704 23.141 28.0761 23.141 27.7692C23.141 27.4623 23.0191 27.168 22.8021 26.951C22.5851 26.7341 22.2908 26.6122 21.984 26.6122H8.09936C7.79249 26.6122 7.49818 26.7341 7.28119 26.951C7.0642 27.168 6.9423 27.4623 6.9423 27.7692C6.9423 28.0761 7.0642 28.3704 7.28119 28.5874C7.49818 28.8044 7.79249 28.9263 8.09936 28.9263Z"
				fill={color}
			/>
			<path
				d="M14.0774 7.80684C14.3628 7.99755 14.6984 8.0994 15.0417 8.0994C15.5018 8.09899 15.9431 7.91595 16.2684 7.59056C16.5938 7.26516 16.7768 6.824 16.7772 6.36382C16.7772 6.02056 16.6754 5.68503 16.4847 5.39962C16.294 5.1142 16.023 4.89172 15.7058 4.76036C15.3887 4.62899 15.0397 4.59461 14.7031 4.66158C14.3664 4.72855 14.0571 4.8938 13.8144 5.13653C13.5717 5.37925 13.4064 5.68855 13.3394 6.02522C13.2725 6.36189 13.3068 6.71081 13.4382 7.02794C13.5696 7.34508 13.792 7.61614 14.0774 7.80684Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.0417 0C16.6819 0.00180967 18.2688 0.583414 19.5217 1.64207C20.7746 2.70074 21.6128 4.16828 21.8883 5.78526H26.6122C27.5324 5.78648 28.4146 6.15253 29.0653 6.80323C29.716 7.45393 30.0821 8.33618 30.0833 9.25641V33.5545C30.0821 34.4747 29.716 35.3569 29.0653 36.0076C28.4146 36.6583 27.5324 37.0244 26.6122 37.0256H3.47115C2.55092 37.0244 1.66872 36.6583 1.01802 36.0076C0.36732 35.3569 0.00122453 34.4747 0 33.5545V9.25641C0.00122453 8.33618 0.36732 7.45393 1.01802 6.80323C1.66872 6.15253 2.55092 5.78648 3.47115 5.78526H8.19653C8.47199 4.16855 9.31004 2.70118 10.5626 1.64255C11.8152 0.583916 13.4017 0.00217333 15.0417 0ZM26.6122 34.7115C26.9189 34.7111 27.213 34.5891 27.4299 34.3722C27.6468 34.1553 27.7688 33.8612 27.7692 33.5545V9.25641C27.7688 8.94967 27.6468 8.65562 27.4299 8.43872C27.213 8.22181 26.9189 8.09977 26.6122 8.09936H20.8269C20.5201 8.09936 20.2257 7.97746 20.0088 7.76047C19.7918 7.54348 19.6699 7.24918 19.6699 6.94231C19.6699 5.71483 19.1822 4.5376 18.3143 3.66965C17.4463 2.80169 16.2691 2.3141 15.0417 2.3141C13.8142 2.3141 12.637 2.80169 11.7691 3.66965C10.9011 4.5376 10.4135 5.71483 10.4135 6.94231C10.4135 7.24918 10.2916 7.54348 10.0746 7.76047C9.85759 7.97746 9.56328 8.09936 9.25641 8.09936H3.47115C3.16441 8.09977 2.87036 8.22181 2.65346 8.43872C2.43656 8.65562 2.31451 8.94967 2.3141 9.25641V33.5545C2.31451 33.8612 2.43656 34.1553 2.65346 34.3722C2.87036 34.5891 3.16441 34.7111 3.47115 34.7115H26.6122Z"
				fill={color}
			/>
		</svg>
	),

	// DEBIT_CARD_IN_HAND:  ({ color, height }) => <></>,
	// CREDIT_CARD_IN_HAND:  ({ color, height }) => <></>,
	// GREEN_CHECK:  ({ color, height }) => <></>,
	// LARGE_PRODUCT_CURVE:  ({ color, height }) => <></>,
	// PRODUCTS:  ({ color, height }) => <></>,
	// CREDIT_CHECK:  ({ color, height }) => <></>,
	// MONEY_PRODUCT:  ({ color, height }) => <></>,
	// LOG_OUT:  ({ color, height }) => <></>,
} as const satisfies Record<string, SvgComponent>;
